const T = {

  en: {
    nav: {
      dashboard:    "Dashboard",
      prices:       "Mandi Prices",
      cropDoctor:   "Crop Doctor",
      aiChat:       "AI Assistant",
      weather:      "Weather",
      soil:         "Soil Health",
      advisory:     "Crop Advisory",
      schemes:      "Gov Schemes",
      decision:     "Smart Tools",
      market:       "Market Intel",
      cropIntel:    "Crop Intel",
      community:    "Community",
      profile:      "Profile",
      pricing:      "Pricing",
      logout:       "Logout",
      login:        "Login",
      register:     "Register"
    },
    common: {
      loading:      "Loading...",
      error:        "Something went wrong",
      retry:        "Try Again",
      save:         "Save",
      cancel:       "Cancel",
      back:         "Back",
      next:         "Next",
      done:         "Done",
      yes:          "Yes",
      no:           "No",
      search:       "Search",
      filter:       "Filter",
      viewMore:     "View More",
      close:        "Close",
      submit:       "Submit",
      edit:         "Edit",
      delete:       "Delete",
      share:        "Share",
      copy:         "Copy",
      copied:       "Copied!",
      helpline:     "Helpline: 1551",
      source:       "Source",
      expert:       "Expert",
      free:         "Free",
      paid:         "Paid"
    },
    dashboard: {
      greeting:     "Hello",
      goodMorning:  "Good Morning",
      goodAfternoon:"Good Afternoon",
      goodEvening:  "Good Evening",
      myFarm:       "My Farm",
      todayPrices:  "Today's Prices",
      weatherAlert: "Weather Alert",
      weeklyTip:    "Weekly Tip",
      noData:       "Loading data...",
      viewAll:      "View All",
      myAlerts:     "My Alerts",
      quickActions: "Quick Actions"
    },
    chat: {
      title:          "AI Assistant",
      subtitle:       "Ask anything about farming",
      placeholder:    "Type your question...",
      send:           "Send",
      listening:      "Listening...",
      stopListening:  "Stop",
      thinking:       "Fetching real data...",
      welcome:        "Hello! I am FassalkartAI. Ask me anything about crops, prices, weather or schemes.",
      voiceHint:      "Tap mic and speak. Auto-stops after 3 sec silence.",
      noAutoSend:     "Voice captured. Press Send when ready.",
      quickQ1:        "Today's wheat price?",
      quickQ2:        "Will it rain this week?",
      quickQ3:        "My crop has disease",
      quickQ4:        "When to apply fertilizer?",
      quickQ5:        "PM-KISAN status",
      sources:        "Data Sources",
      liveData:       "Live Data",
      expertKB:       "Expert Advisory"
    },
    cropDoctor: {
      title:          "Crop Doctor",
      subtitle:       "Take photo → instant diagnosis",
      selectCrop:     "Which crop? *",
      selectPart:     "Affected part? *",
      moreInfo:       "Additional details (optional)",
      moreInfoHint:   "Since when? Previous treatments?",
      camera:         "Camera",
      gallery:        "Gallery",
      analyze:        "Diagnose Now",
      analyzing:      "AI analyzing photo...",
      newPhoto:       "New Photo",
      share:          "Share Result",
      history:        "Past Diagnoses",
      noHistory:      "No diagnoses yet",
      newDiagnosis:   "New Diagnosis",
      saved:          "Diagnosis saved!",
      urgent:         "URGENT - Treat today!",
      symptoms:       "Symptoms",
      chemical:       "Chemical Treatment",
      organic:        "Organic Treatment",
      prevention:     "Prevention",
      healthy:        "Crop is Healthy!",
      confidence:     "AI Confidence",
      parts: ["Leaf","Stem","Root",
              "Flower","Fruit","Seed","Whole Plant"],
      severity: {
        mild:"Mild", moderate:"Moderate",
        severe:"Severe", critical:"Critical"
      }
    },
    weather: {
      title:    "Weather",
      today:    "Today",
      tomorrow: "Tomorrow",
      weekly:   "7-Day Forecast",
      rain:     "Rainfall",
      temp:     "Temperature",
      humidity: "Humidity",
      wind:     "Wind Speed",
      noSpray:  "Do NOT spray today - rain expected",
      irrigate: "Irrigation needed this week",
      heatWave: "Heat wave - irrigate morning/evening",
      frost:    "Frost risk - cover sensitive crops"
    },
    prices: {
      title:    "Mandi Prices",
      today:    "Today's Price",
      trend:    "Trend",
      msp:      "MSP (Govt Support Price)",
      aboveMsp: "Above MSP",
      belowMsp: "Below MSP",
      rising:   "Rising",
      falling:  "Falling",
      stable:   "Stable",
      sellNow:  "Good time to SELL",
      wait:     "Consider waiting",
      noData:   "Price not available today",
      perQtl:   "per quintal",
      weekAvg:  "7-day average"
    },
    profile: {
      title:       "My Profile",
      name:        "Full Name",
      phone:       "Phone Number",
      language:    "Language",
      state:       "State",
      district:    "District",
      village:     "Village",
      landSize:    "Land Size",
      crops:       "My Crops",
      soil:        "Soil Type",
      irrigation:  "Irrigation Type",
      farming:     "Farming Type",
      whatsapp:    "WhatsApp Number",
      saveProfile: "Save Profile",
      saved:       "Profile saved!",
      changePhoto: "Change Photo"
    },
    langSelect: {
      title:   "Choose Language",
      subtitle:"Select your preferred language",
      saved:   "Language changed!"
    },
    cropIntelligence: {
      title:"Crop Intelligence", subtitle:"Real data • Weather advisory • AI analysis",
      calendar:"Calendar", varieties:"Varieties", fertilizer:"Fertilizer",
      crop:"Crop", sort:"Sort", profitable:"Most Profitable", cultivated:"Most Cultivated", suitable:"Suitable",
      duration:"Duration", days:"days", seedRate:"Seed rate", sowingMethod:"Sowing method",
      transplanting:"Transplanting", marketPremium:"Market premium", quality:"Quality",
      diseaseRes:"Disease resistance:", source:"Source:", grafts:"Grafts/Suckers",
      profChip:"💰 Most Profitable", cultChip:"🏆 Most Cultivated",
      nitrogen:"Nitrogen", phosphorus:"Phosphorus", potassium:"Potassium",
      land:"Land", unit:"Unit", fertTitle:"Fertilizer Planner", acre:"acre",
      fertPrices:"Fertilizer prices (₹/bag) — edit for your area:",
      npkReq:"NPK Requirements", fertBags:"Fertilizer bags needed:",
      totalCost:"Total Cost", perAcre:"Per acre", appSchedule:"Application Schedule",
      stageLabel:"Stage", qty:"Qty", bags:"Bags", cost:"Cost", bagsUnit:"bags",
      urea:"Urea 50 kg", ureaFull:"Urea (50 kg)", zinc:"Zinc 25 kg", zincFull:"Zinc Sulphate (25 kg)",
      now:"Now", getAnalysis:"Get Analysis from FassalkartAI", analyzing:"Analyzing...",
      analysisIn:"Analysis in", retry:"Retry",
      analysisTitle:"FassalkartAI Analysis", liveWeather:"Live Weather",
      byFassalkartAI:"by FassalkartAI",
      loadingWeather:"Loading weather data...", yourLocation:"Your Location",
      humidity:"Humidity", rain:"Rain",
      safeToSpray:"✅ Safe to spray", avoidSpraying:"❌ Avoid spraying",
      allGrowthStages:"All Growth Stages", tasks:"tasks —",
      fullYearCalendar:"Full Year Calendar —",
      noCalendar:"Get detailed crop calendar from FassalkartAI below.",
      noVarieties:"Get detailed variety recommendations from FassalkartAI below.",
      noFertilizer:"Get detailed fertilizer plan from FassalkartAI below.",
      months:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
    },
    seeds: {
      title:       "Find Best Seeds",
      selectCrop:  "Select Crop",
      selectSeason:"Select Season",
      findSeeds:   "Find Seeds",
      searching:   "Searching seeds...",
      recommended: "Recommended",
      suitability: "Suitability Score",
      yield:       "Yield",
      maturity:    "Maturity",
      seedRate:    "Seed Rate",
      findDealer:  "Find Dealer",
      compare:     "Compare",
      share:       "Share",
      bestChoice:  "Best Choice",
      noSeeds:     "No seeds found for your area",
      droughtTol:  "Drought Tolerant",
      heatTol:     "Heat Tolerant",
      floodTol:    "Flood Tolerant",
      coldTol:     "Cold Tolerant",
      diseaseRes:  "Disease Resistant",
      approved:    "Govt. Approved",
      days:        "days",
      quintal:     "quintal"
    }
  },

  hi: {
    nav: {
      dashboard:    "डैशबोर्ड",
      prices:       "मंडी भाव",
      cropDoctor:   "फसल डॉक्टर",
      aiChat:       "AI सहायक",
      weather:      "मौसम",
      soil:         "मिट्टी",
      advisory:     "फसल सलाह",
      schemes:      "सरकारी योजनाएं",
      decision:     "स्मार्ट टूल्स",
      market:       "बाजार जानकारी",
      cropIntel:    "फसल विज्ञान",
      community:    "किसान समुदाय",
      profile:      "प्रोफाइल",
      pricing:      "मूल्य सूची",
      logout:       "लॉग आउट",
      login:        "लॉग इन",
      register:     "रजिस्टर"
    },
    common: {
      loading:      "लोड हो रहा है...",
      error:        "कुछ गलत हो गया",
      retry:        "दोबारा कोशिश करें",
      save:         "सेव करें",
      cancel:       "रद्द करें",
      back:         "वापस",
      next:         "आगे",
      done:         "हो गया",
      yes:          "हां",
      no:           "नहीं",
      search:       "खोजें",
      filter:       "फिल्टर",
      viewMore:     "और देखें",
      close:        "बंद करें",
      submit:       "जमा करें",
      edit:         "बदलें",
      delete:       "हटाएं",
      share:        "शेयर करें",
      copy:         "कॉपी करें",
      copied:       "कॉपी हो गया!",
      helpline:     "सहायता: 1551",
      source:       "स्रोत",
      expert:       "विशेषज्ञ",
      free:         "मुफ्त",
      paid:         "भुगतान"
    },
    dashboard: {
      greeting:     "नमस्ते",
      goodMorning:  "सुप्रभात",
      goodAfternoon:"नमस्कार",
      goodEvening:  "शुभ संध्या",
      myFarm:       "मेरी खेती",
      todayPrices:  "आज के मंडी भाव",
      weatherAlert: "मौसम अलर्ट",
      weeklyTip:    "साप्ताहिक सलाह",
      noData:       "डेटा लोड हो रहा है...",
      viewAll:      "सब देखें",
      myAlerts:     "मेरे अलर्ट",
      quickActions: "तुरंत काम"
    },
    chat: {
      title:         "AI सहायक",
      subtitle:      "खेती के बारे में कुछ भी पूछें",
      placeholder:   "हिंदी या English में लिखें...",
      send:          "भेजें",
      listening:     "सुन रहा हूं...",
      stopListening: "रोकें",
      thinking:      "असली डेटा ला रहा हूं...",
      welcome:       "नमस्ते! मैं FassalkartAI हूं। फसल, भाव, मौसम, योजना — कुछ भी पूछें।",
      voiceHint:     "माइक दबाएं और बोलें। 3 सेकंड चुप रहने पर खुद रुक जाएगा।",
      noAutoSend:    "आवाज़ रिकॉर्ड हुई। भेजने के लिए Send दबाएं।",
      quickQ1:       "आज गेहूं का भाव क्या है?",
      quickQ2:       "इस हफ्ते बारिश होगी क्या?",
      quickQ3:       "मेरी फसल में बीमारी लगी है",
      quickQ4:       "खाद कब और कितनी डालें?",
      quickQ5:       "PM-KISAN स्टेटस चेक करें",
      sources:       "डेटा स्रोत",
      liveData:      "लाइव डेटा",
      expertKB:      "विशेषज्ञ सलाह"
    },
    cropDoctor: {
      title:         "फसल डॉक्टर",
      subtitle:      "फोटो लो → तुरंत पहचान पाओ",
      selectCrop:    "कौन सी फसल? *",
      selectPart:    "कौनसा हिस्सा? *",
      moreInfo:      "कुछ और बताएं (optional)",
      moreInfoHint:  "कितने दिन से? पहले क्या किया?",
      camera:        "कैमरा",
      gallery:       "गैलरी",
      analyze:       "पहचान करें",
      analyzing:     "AI फोटो देख रहा है...",
      newPhoto:      "नई फोटो",
      share:         "शेयर करें",
      history:       "पिछली जांच",
      noHistory:     "अभी कोई जांच नहीं",
      newDiagnosis:  "नई जांच",
      saved:         "जांच सेव हो गई!",
      urgent:        "जरूरी — आज ही इलाज करें!",
      symptoms:      "लक्षण",
      chemical:      "रासायनिक उपचार",
      organic:       "जैविक उपचार",
      prevention:    "बचाव",
      healthy:       "फसल स्वस्थ है!",
      confidence:    "AI का भरोसा",
      parts: ["पत्ता","तना","जड़",
              "फूल","फल","बीज","पूरा पौधा"],
      severity: {
        mild:"हल्का", moderate:"मध्यम",
        severe:"गंभीर", critical:"अति गंभीर"
      }
    },
    weather: {
      title:    "मौसम",
      today:    "आज",
      tomorrow: "कल",
      weekly:   "7 दिन का पूर्वानुमान",
      rain:     "बारिश",
      temp:     "तापमान",
      humidity: "नमी",
      wind:     "हवा",
      noSpray:  "आज spray मत करें — बारिश आएगी",
      irrigate: "इस हफ्ते सिंचाई जरूरी",
      heatWave: "लू — सुबह/शाम ही सिंचाई करें",
      frost:    "पाला पड़ेगा — फसल ढकें"
    },
    prices: {
      title:    "मंडी भाव",
      today:    "आज का भाव",
      trend:    "रुझान",
      msp:      "MSP (सरकारी समर्थन मूल्य)",
      aboveMsp: "MSP से ऊपर",
      belowMsp: "MSP से नीचे",
      rising:   "बढ़ रहा",
      falling:  "गिर रहा",
      stable:   "स्थिर",
      sellNow:  "बेचने का अच्छा समय",
      wait:     "थोड़ा इंतजार करें",
      noData:   "आज का भाव अभी नहीं आया",
      perQtl:   "प्रति क्विंटल",
      weekAvg:  "7 दिन का औसत"
    },
    profile: {
      title:       "मेरी प्रोफाइल",
      name:        "पूरा नाम",
      phone:       "फोन नंबर",
      language:    "भाषा",
      state:       "राज्य",
      district:    "जिला",
      village:     "गांव",
      landSize:    "ज़मीन का साइज़",
      crops:       "मेरी फसलें",
      soil:        "मिट्टी का प्रकार",
      irrigation:  "सिंचाई का तरीका",
      farming:     "खेती का तरीका",
      whatsapp:    "WhatsApp नंबर",
      saveProfile: "प्रोफाइल सेव करें",
      saved:       "प्रोफाइल सेव हो गई!",
      changePhoto: "फोटो बदलें"
    },
    langSelect: {
      title:   "भाषा चुनें",
      subtitle:"अपनी पसंदीदा भाषा चुनें",
      saved:   "भाषा बदल गई!"
    },
    cropIntelligence: {
      title:"फसल बुद्धिमत्ता", subtitle:"असली डेटा • मौसम सलाह • AI विश्लेषण",
      calendar:"कैलेंडर", varieties:"किस्में", fertilizer:"उर्वरक",
      crop:"फसल", sort:"क्रम", profitable:"सबसे लाभदायक", cultivated:"सबसे लोकप्रिय", suitable:"उपयुक्त",
      duration:"अवधि", days:"दिन", seedRate:"बीज दर", sowingMethod:"बुवाई विधि",
      transplanting:"रोपाई विधि", marketPremium:"बाज़ार लाभ", quality:"गुणवत्ता",
      diseaseRes:"रोग प्रतिरोधकता:", source:"स्रोत:", grafts:"पौध",
      profChip:"💰 सबसे लाभदायक", cultChip:"🏆 सर्वाधिक खेती",
      nitrogen:"नाइट्रोजन", phosphorus:"फास्फोरस", potassium:"पोटाश",
      land:"ज़मीन", unit:"इकाई", fertTitle:"उर्वरक योजनाकार",
      fertPrices:"उर्वरक कीमतें (₹/बैग) — बदलें अगर अलग हों:",
      npkReq:"NPK आवश्यकताएं", fertBags:"खाद की थैलियां:",
      totalCost:"कुल लागत", perAcre:"प्रति एकड़", appSchedule:"प्रयोग अनुसूची",
      stageLabel:"चरण", qty:"मात्रा", bags:"थैले", cost:"लागत", bagsUnit:"थैले",
      urea:"यूरिया 50 kg", ureaFull:"यूरिया (50 kg)", zinc:"जिंक 25 kg", zincFull:"जिंक सल्फेट (25 kg)",
      now:"अभी", getAnalysis:"FassalkartAI से विश्लेषण लें", analyzing:"विश्लेषण हो रहा है...",
      analysisIn:"विश्लेषण भाषा:", retry:"फिर करें",
      analysisTitle:"FassalkartAI विश्लेषण", liveWeather:"लाइव मौसम",
      byFassalkartAI:"FassalkartAI द्वारा", acre:"एकड़",
      loadingWeather:"मौसम डेटा लोड हो रहा है...", yourLocation:"आपका क्षेत्र",
      humidity:"नमी", rain:"बारिश",
      safeToSpray:"✅ छिड़काव ठीक है", avoidSpraying:"❌ छिड़काव न करें",
      allGrowthStages:"सभी विकास अवस्थाएं", tasks:"में करें —",
      fullYearCalendar:"पूरे साल का कैलेंडर —",
      noCalendar:"नीचे FassalkartAI से विस्तृत फसल कैलेंडर पाएं।",
      noVarieties:"नीचे FassalkartAI से विस्तृत किस्म सिफारिश पाएं।",
      noFertilizer:"नीचे FassalkartAI से विस्तृत खाद योजना पाएं।",
      months:["जनवरी","फरवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितंबर","अक्टूबर","नवंबर","दिसंबर"]
    },
    seeds: {
      title:       "सबसे अच्छे बीज खोजें",
      selectCrop:  "फसल चुनें",
      selectSeason:"मौसम चुनें",
      findSeeds:   "बीज खोजें",
      searching:   "बीज खोज रहे हैं...",
      recommended: "सुझाए गए",
      suitability: "उपयुक्तता",
      yield:       "उत्पादन",
      maturity:    "पकने का समय",
      seedRate:    "बीज दर",
      findDealer:  "डीलर खोजें",
      compare:     "तुलना करें",
      share:       "शेयर करें",
      bestChoice:  "सबसे अच्छा",
      noSeeds:     "आपके क्षेत्र में बीज नहीं मिले",
      droughtTol:  "सूखा सहनशील",
      heatTol:     "गर्मी सहनशील",
      floodTol:    "बाढ़ सहनशील",
      coldTol:     "ठंड सहनशील",
      diseaseRes:  "रोग प्रतिरोधी",
      approved:    "सरकारी अनुमोदित",
      days:        "दिन",
      quintal:     "क्विंटल"
    }
  },

  bn: {
    nav: {
      dashboard:    "ড্যাশবোর্ড",
      prices:       "মণ্ডি দাম",
      cropDoctor:   "ফসল ডাক্তার",
      aiChat:       "AI সহায়ক",
      weather:      "আবহাওয়া",
      soil:         "মাটি",
      advisory:     "ফসল পরামর্শ",
      schemes:      "সরকারি প্রকল্প",
      decision:     "স্মার্ট টুলস",
      market:       "বাজার তথ্য",
      cropIntel:    "ফসল বিজ্ঞান",
      community:    "কৃষক সমাজ",
      profile:      "প্রোফাইল",
      pricing:      "মূল্য তালিকা",
      logout:       "লগ আউট",
      login:        "লগ ইন",
      register:     "নিবন্ধন"
    },
    common: {
      loading:      "লোড হচ্ছে...",
      error:        "কিছু ভুল হয়েছে",
      retry:        "আবার চেষ্টা করুন",
      save:         "সেভ করুন",
      cancel:       "বাতিল",
      back:         "পিছনে",
      next:         "এগিয়ে যান",
      done:         "হয়ে গেছে",
      yes:          "হ্যাঁ",
      no:           "না",
      search:       "খুঁজুন",
      filter:       "ফিল্টার",
      viewMore:     "আরো দেখুন",
      close:        "বন্ধ করুন",
      submit:       "জমা দিন",
      edit:         "সম্পাদনা",
      delete:       "মুছুন",
      share:        "শেয়ার করুন",
      copy:         "কপি করুন",
      copied:       "কপি হয়েছে!",
      helpline:     "সহায়তা: 1551",
      source:       "উৎস",
      expert:       "বিশেষজ্ঞ",
      free:         "বিনামূল্যে",
      paid:         "প্রদত্ত"
    },
    dashboard: {
      greeting:     "নমস্কার",
      goodMorning:  "সুপ্রভাত",
      goodAfternoon:"নমস্কার",
      goodEvening:  "শুভ সন্ধ্যা",
      myFarm:       "আমার খামার",
      todayPrices:  "আজকের মণ্ডি দাম",
      weatherAlert: "আবহাওয়া সতর্কতা",
      weeklyTip:    "সাপ্তাহিক পরামর্শ",
      noData:       "ডেটা লোড হচ্ছে...",
      viewAll:      "সব দেখুন",
      myAlerts:     "আমার সতর্কতা",
      quickActions: "দ্রুত কাজ"
    },
    chat: {
      title:         "AI সহায়ক",
      subtitle:      "চাষ সম্পর্কে যেকোনো প্রশ্ন করুন",
      placeholder:   "বাংলা বা English এ লিখুন...",
      send:          "পাঠান",
      listening:     "শুনছি...",
      stopListening: "থামুন",
      thinking:      "আসল ডেটা আনছি...",
      welcome:       "নমস্কার! আমি FassalkartAI। ফসল, দাম, আবহাওয়া, প্রকল্প — যেকোনো প্রশ্ন করুন।",
      voiceHint:     "মাইক চাপুন এবং বলুন। ৩ সেকেন্ড চুপ থাকলে নিজে থামবে।",
      noAutoSend:    "কথা রেকর্ড হয়েছে। পাঠাতে Send চাপুন।",
      quickQ1:       "আজ গমের দাম কত?",
      quickQ2:       "এই সপ্তাহে বৃষ্টি হবে কি?",
      quickQ3:       "আমার ফসলে রোগ লেগেছে",
      quickQ4:       "সার কখন এবং কতটুকু দেব?",
      quickQ5:       "PM-KISAN স্ট্যাটাস দেখুন",
      sources:       "ডেটা উৎস",
      liveData:      "লাইভ ডেটা",
      expertKB:      "বিশেষজ্ঞ পরামর্শ"
    },
    cropDoctor: {
      title:         "ফসল ডাক্তার",
      subtitle:      "ছবি তুলুন → তাৎক্ষণিক রোগ নির্ণয়",
      selectCrop:    "কোন ফসল? *",
      selectPart:    "কোন অংশ? *",
      moreInfo:      "আর কিছু বলতে চান? (optional)",
      moreInfoHint:  "কতদিন ধরে? আগে কী করেছিলেন?",
      camera:        "ক্যামেরা",
      gallery:       "গ্যালারি",
      analyze:       "নির্ণয় করুন",
      analyzing:     "AI ছবি দেখছে...",
      newPhoto:      "নতুন ছবি",
      share:         "শেয়ার করুন",
      history:       "পূর্ববর্তী পরীক্ষা",
      noHistory:     "এখনো কোনো পরীক্ষা নেই",
      newDiagnosis:  "নতুন পরীক্ষা",
      saved:         "পরীক্ষা সেভ হয়েছে!",
      urgent:        "জরুরি — আজই চিকিৎসা করুন!",
      symptoms:      "লক্ষণ",
      chemical:      "রাসায়নিক চিকিৎসা",
      organic:       "জৈব চিকিৎসা",
      prevention:    "প্রতিরোধ",
      healthy:       "ফসল সুস্থ আছে!",
      confidence:    "AI এর আস্থা",
      parts: ["পাতা","কাণ্ড","শিকড়",
              "ফুল","ফল","বীজ","পুরো গাছ"],
      severity: {
        mild:"সামান্য", moderate:"মাঝারি",
        severe:"গুরুতর", critical:"অতি গুরুতর"
      }
    },
    weather: {
      title:    "আবহাওয়া",
      today:    "আজ",
      tomorrow: "আগামীকাল",
      weekly:   "৭ দিনের পূর্বাভাস",
      rain:     "বৃষ্টি",
      temp:     "তাপমাত্রা",
      humidity: "আর্দ্রতা",
      wind:     "বাতাস",
      noSpray:  "আজ স্প্রে করবেন না — বৃষ্টি আসবে",
      irrigate: "এই সপ্তাহে সেচ দরকার",
      heatWave: "তাপপ্রবাহ — সকাল/সন্ধ্যায় সেচ দিন",
      frost:    "তুষারপাত — ফসল ঢেকে রাখুন"
    },
    prices: {
      title:    "মণ্ডি দাম",
      today:    "আজকের দাম",
      trend:    "প্রবণতা",
      msp:      "MSP (সরকারি সহায়তা মূল্য)",
      aboveMsp: "MSP এর উপরে",
      belowMsp: "MSP এর নিচে",
      rising:   "বাড়ছে",
      falling:  "কমছে",
      stable:   "স্থির",
      sellNow:  "বিক্রির ভালো সময়",
      wait:     "একটু অপেক্ষা করুন",
      noData:   "আজকের দাম এখনো আসেনি",
      perQtl:   "প্রতি কুইন্টাল",
      weekAvg:  "৭ দিনের গড়"
    },
    profile: {
      title:       "আমার প্রোফাইল",
      name:        "পূর্ণ নাম",
      phone:       "ফোন নম্বর",
      language:    "ভাষা",
      state:       "রাজ্য",
      district:    "জেলা",
      village:     "গ্রাম",
      landSize:    "জমির পরিমাণ",
      crops:       "আমার ফসল",
      soil:        "মাটির ধরন",
      irrigation:  "সেচের পদ্ধতি",
      farming:     "চাষের পদ্ধতি",
      whatsapp:    "WhatsApp নম্বর",
      saveProfile: "প্রোফাইল সেভ করুন",
      saved:       "প্রোফাইল সেভ হয়েছে!",
      changePhoto: "ছবি পরিবর্তন করুন"
    },
    langSelect: {
      title:   "ভাষা বেছে নিন",
      subtitle:"আপনার পছন্দের ভাষা বেছে নিন",
      saved:   "ভাষা পরিবর্তন হয়েছে!"
    },
    cropIntelligence: {
      title:"ফসল বিজ্ঞান", subtitle:"আসল তথ্য • আবহাওয়া পরামর্শ • AI বিশ্লেষণ",
      calendar:"ক্যালেন্ডার", varieties:"জাত", fertilizer:"সার",
      crop:"ফসল", sort:"বাছাই", profitable:"সবচেয়ে লাভজনক", cultivated:"সবচেয়ে প্রচলিত", suitable:"উপযুক্ত",
      duration:"মেয়াদ", days:"দিন", seedRate:"বীজের পরিমাণ", sowingMethod:"বপন পদ্ধতি",
      transplanting:"রোপণ পদ্ধতি", marketPremium:"বাজার সুবিধা", quality:"গুণমান",
      diseaseRes:"রোগ প্রতিরোধ:", source:"উৎস:", grafts:"চারা",
      profChip:"💰 সবচেয়ে লাভজনক", cultChip:"🏆 সবচেয়ে প্রচলিত",
      nitrogen:"নাইট্রোজেন", phosphorus:"ফসফরাস", potassium:"পটাশ",
      land:"জমি", unit:"একক", fertTitle:"সার পরিকল্পনাকারী",
      fertPrices:"সারের দাম (₹/বস্তা) — এলাকা অনুযায়ী পরিবর্তন করুন:",
      npkReq:"NPK প্রয়োজনীয়তা", fertBags:"সারের বস্তা:",
      totalCost:"মোট খরচ", perAcre:"প্রতি একর", appSchedule:"প্রয়োগ সূচি",
      stageLabel:"ধাপ", qty:"পরিমাণ", bags:"বস্তা", cost:"খরচ", bagsUnit:"বস্তা",
      urea:"ইউরিয়া 50 kg", ureaFull:"ইউরিয়া (50 kg)", zinc:"জিংক 25 kg", zincFull:"জিংক সালফেট (25 kg)",
      now:"এখন", getAnalysis:"FassalkartAI থেকে বিশ্লেষণ নিন", analyzing:"বিশ্লেষণ হচ্ছে...",
      analysisIn:"বিশ্লেষণ ভাষা:", retry:"পুনরায়",
      analysisTitle:"FassalkartAI বিশ্লেষণ", liveWeather:"লাইভ আবহাওয়া",
      byFassalkartAI:"FassalkartAI দ্বারা", acre:"একর",
      loadingWeather:"আবহাওয়া তথ্য লোড হচ্ছে...", yourLocation:"আপনার এলাকা",
      humidity:"আর্দ্রতা", rain:"বৃষ্টি",
      safeToSpray:"✅ স্প্রে করা নিরাপদ", avoidSpraying:"❌ স্প্রে করবেন না",
      allGrowthStages:"সব বৃদ্ধি পর্যায়", tasks:"কাজ —",
      fullYearCalendar:"সারা বছরের ক্যালেন্ডার —",
      noCalendar:"নীচে FassalkartAI থেকে বিস্তারিত ফসল ক্যালেন্ডার পান।",
      noVarieties:"নীচে FassalkartAI থেকে বিস্তারিত জাত সুপারিশ পান।",
      noFertilizer:"নীচে FassalkartAI থেকে বিস্তারিত সার পরিকল্পনা পান।",
      months:["জানুয়ারি","ফেব্রুয়ারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"]
    },
    seeds: {
      title:       "সেরা বীজ খুঁজুন",
      selectCrop:  "ফসল বেছে নিন",
      selectSeason:"মৌসুম বেছে নিন",
      findSeeds:   "বীজ খুঁজুন",
      searching:   "বীজ খোঁজা হচ্ছে...",
      recommended: "প্রস্তাবিত",
      suitability: "উপযুক্ততা",
      yield:       "উৎপাদন",
      maturity:    "পরিপক্বতা",
      seedRate:    "বীজের পরিমাণ",
      findDealer:  "ডিলার খুঁজুন",
      compare:     "তুলনা করুন",
      share:       "শেয়ার করুন",
      bestChoice:  "সেরা পছন্দ",
      noSeeds:     "আপনার এলাকায় বীজ পাওয়া যায়নি",
      droughtTol:  "খরা সহনশীল",
      heatTol:     "তাপ সহনশীল",
      floodTol:    "বন্যা সহনশীল",
      coldTol:     "শীত সহনশীল",
      diseaseRes:  "রোগ প্রতিরোধী",
      approved:    "সরকার অনুমোদিত",
      days:        "দিন",
      quintal:     "কুইন্টাল"
    }
  },

  mr: {
    nav: {
      dashboard:    "डॅशबोर्ड",
      prices:       "मंडी भाव",
      cropDoctor:   "पीक डॉक्टर",
      aiChat:       "AI सहाय्यक",
      weather:      "हवामान",
      soil:         "माती",
      advisory:     "पीक सल्ला",
      schemes:      "सरकारी योजना",
      decision:     "स्मार्ट साधने",
      market:       "बाजार माहिती",
      cropIntel:    "पीक विज्ञान",
      community:    "शेतकरी समुदाय",
      profile:      "प्रोफाइल",
      pricing:      "किंमत यादी",
      logout:       "लॉग आउट",
      login:        "लॉग इन",
      register:     "नोंदणी"
    },
    common: {
      loading:      "लोड होत आहे...",
      error:        "काहीतरी चुकले",
      retry:        "पुन्हा प्रयत्न करा",
      save:         "सेव्ह करा",
      cancel:       "रद्द करा",
      back:         "मागे",
      next:         "पुढे",
      done:         "झाले",
      yes:          "होय",
      no:           "नाही",
      search:       "शोधा",
      filter:       "फिल्टर",
      viewMore:     "अधिक पहा",
      close:        "बंद करा",
      submit:       "सादर करा",
      edit:         "संपादित करा",
      delete:       "हटवा",
      share:        "शेअर करा",
      copy:         "कॉपी करा",
      copied:       "कॉपी झाले!",
      helpline:     "मदत: 1551",
      source:       "स्रोत",
      expert:       "तज्ञ",
      free:         "मोफत",
      paid:         "सशुल्क"
    },
    dashboard: {
      greeting:     "नमस्कार",
      goodMorning:  "सुप्रभात",
      goodAfternoon:"नमस्कार",
      goodEvening:  "शुभ संध्याकाळ",
      myFarm:       "माझी शेती",
      todayPrices:  "आजचे मंडी भाव",
      weatherAlert: "हवामान इशारा",
      weeklyTip:    "साप्ताहिक सल्ला",
      noData:       "डेटा लोड होत आहे...",
      viewAll:      "सर्व पहा",
      myAlerts:     "माझे इशारे",
      quickActions: "जलद कृती"
    },
    chat: {
      title:         "AI सहाय्यक",
      subtitle:      "शेतीबद्दल काहीही विचारा",
      placeholder:   "मराठी किंवा English मध्ये लिहा...",
      send:          "पाठवा",
      listening:     "ऐकत आहे...",
      stopListening: "थांबा",
      thinking:      "खरी माहिती आणत आहे...",
      welcome:       "नमस्कार! मी FassalkartAI। पीक, भाव, हवामान, योजना — काहीही विचारा।",
      voiceHint:     "माइक दाबा आणि बोला। ३ सेकंद शांत राहिल्यास आपोआप थांबेल।",
      noAutoSend:    "आवाज रेकॉर्ड झाला. पाठवण्यासाठी Send दाबा।",
      quickQ1:       "आज गव्हाचा भाव काय?",
      quickQ2:       "या आठवड्यात पाऊस येईल का?",
      quickQ3:       "माझ्या पिकाला रोग लागला",
      quickQ4:       "खत कधी आणि किती द्यायचे?",
      quickQ5:       "PM-KISAN स्टेटस तपासा",
      sources:       "डेटा स्रोत",
      liveData:      "थेट डेटा",
      expertKB:      "तज्ञ सल्ला"
    },
    cropDoctor: {
      title:         "पीक डॉक्टर",
      subtitle:      "फोटो काढा → तात्काळ निदान मिळवा",
      selectCrop:    "कोणते पीक? *",
      selectPart:    "कोणता भाग? *",
      moreInfo:      "आणखी माहिती? (optional)",
      moreInfoHint:  "किती दिवसांपासून? आधी काय केले?",
      camera:        "कॅमेरा",
      gallery:       "गॅलरी",
      analyze:       "निदान करा",
      analyzing:     "AI फोटो पाहत आहे...",
      newPhoto:      "नवीन फोटो",
      share:         "शेअर करा",
      history:       "मागील तपासण्या",
      noHistory:     "अजून कोणती तपासणी नाही",
      newDiagnosis:  "नवीन तपासणी",
      saved:         "तपासणी सेव्ह झाली!",
      urgent:        "जरुरी — आजच उपचार करा!",
      symptoms:      "लक्षणे",
      chemical:      "रासायनिक उपचार",
      organic:       "सेंद्रिय उपचार",
      prevention:    "प्रतिबंध",
      healthy:       "पीक निरोगी आहे!",
      confidence:    "AI ची खात्री",
      parts: ["पान","खोड","मूळ",
              "फूल","फळ","बीज","संपूर्ण झाड"],
      severity: {
        mild:"सौम्य", moderate:"मध्यम",
        severe:"गंभीर", critical:"अतिशय गंभीर"
      }
    },
    weather: {
      title:    "हवामान",
      today:    "आज",
      tomorrow: "उद्या",
      weekly:   "७ दिवसांचा अंदाज",
      rain:     "पाऊस",
      temp:     "तापमान",
      humidity: "आर्द्रता",
      wind:     "वारा",
      noSpray:  "आज फवारणी करू नका — पाऊस येईल",
      irrigate: "या आठवड्यात पाणी द्या",
      heatWave: "उष्णता — सकाळी/संध्याकाळी पाणी द्या",
      frost:    "दव पडेल — पीक झाका"
    },
    prices: {
      title:    "मंडी भाव",
      today:    "आजचा भाव",
      trend:    "कल",
      msp:      "MSP (सरकारी किमान भाव)",
      aboveMsp: "MSP पेक्षा जास्त",
      belowMsp: "MSP पेक्षा कमी",
      rising:   "वाढत आहे",
      falling:  "कमी होत आहे",
      stable:   "स्थिर",
      sellNow:  "विक्रीची चांगली वेळ",
      wait:     "थोडी प्रतीक्षा करा",
      noData:   "आजचा भाव अजून आला नाही",
      perQtl:   "प्रति क्विंटल",
      weekAvg:  "७ दिवसांची सरासरी"
    },
    profile: {
      title:       "माझी प्रोफाइल",
      name:        "पूर्ण नाव",
      phone:       "फोन नंबर",
      language:    "भाषा",
      state:       "राज्य",
      district:    "जिल्हा",
      village:     "गाव",
      landSize:    "जमिनीचा आकार",
      crops:       "माझी पिके",
      soil:        "मातीचा प्रकार",
      irrigation:  "सिंचनाचा प्रकार",
      farming:     "शेतीचा प्रकार",
      whatsapp:    "WhatsApp नंबर",
      saveProfile: "प्रोफाइल सेव्ह करा",
      saved:       "प्रोफाइल सेव्ह झाली!",
      changePhoto: "फोटो बदला"
    },
    langSelect: {
      title:   "भाषा निवडा",
      subtitle:"तुमची आवडती भाषा निवडा",
      saved:   "भाषा बदलली!"
    },
    cropIntelligence: {
      title:"पीक बुद्धिमत्ता", subtitle:"खरे डेटा • हवामान सल्ला • AI विश्लेषण",
      calendar:"दिनदर्शिका", varieties:"वाण", fertilizer:"खते",
      crop:"पीक", sort:"क्रम", profitable:"सर्वात फायदेशीर", cultivated:"सर्वात लोकप्रिय", suitable:"उपयुक्त",
      duration:"कालावधी", days:"दिवस", seedRate:"बियाणे दर", sowingMethod:"पेरणी पद्धत",
      transplanting:"लावणी पद्धत", marketPremium:"बाजार फायदा", quality:"गुणवत्ता",
      diseaseRes:"रोग प्रतिकारक:", source:"स्रोत:", grafts:"कलमे",
      profChip:"💰 सर्वात फायदेशीर", cultChip:"🏆 सर्वाधिक शेती",
      nitrogen:"नायट्रोजन", phosphorus:"फॉस्फरस", potassium:"पोटॅश",
      land:"जमीन", unit:"एकक", fertTitle:"खत नियोजक",
      fertPrices:"खताच्या किंमती (₹/पोते) — क्षेत्रानुसार बदला:",
      npkReq:"NPK गरजा", fertBags:"खताचे पोते:",
      totalCost:"एकूण खर्च", perAcre:"प्रति एकर", appSchedule:"वापर वेळापत्रक",
      stageLabel:"टप्पा", qty:"प्रमाण", bags:"पोते", cost:"खर्च", bagsUnit:"पोते",
      urea:"युरिया 50 kg", ureaFull:"युरिया (50 kg)", zinc:"झिंक 25 kg", zincFull:"झिंक सल्फेट (25 kg)",
      now:"आत्ता", getAnalysis:"FassalkartAI कडून विश्लेषण घ्या", analyzing:"विश्लेषण होत आहे...",
      analysisIn:"विश्लेषण भाषा:", retry:"पुन्हा करा",
      analysisTitle:"FassalkartAI विश्लेषण", liveWeather:"थेट हवामान",
      byFassalkartAI:"FassalkartAI द्वारे", acre:"एकर",
      loadingWeather:"हवामान माहिती लोड होत आहे...", yourLocation:"तुमचे क्षेत्र",
      humidity:"आर्द्रता", rain:"पाऊस",
      safeToSpray:"✅ फवारणी योग्य आहे", avoidSpraying:"❌ फवारणी करू नका",
      allGrowthStages:"सर्व वाढ अवस्था", tasks:"कामे —",
      fullYearCalendar:"वर्षभराचे दिनदर्शिका —",
      noCalendar:"खाली FassalkartAI कडून सविस्तर पीक दिनदर्शिका मिळवा।",
      noVarieties:"खाली FassalkartAI कडून सविस्तर वाण शिफारस मिळवा।",
      noFertilizer:"खाली FassalkartAI कडून सविस्तर खत योजना मिळवा।",
      months:["जानेवारी","फेब्रुवारी","मार्च","एप्रिल","मे","जून","जुलै","ऑगस्ट","सप्टेंबर","ऑक्टोबर","नोव्हेंबर","डिसेंबर"]
    },
    seeds: {
      title:       "सर्वोत्तम बियाणे शोधा",
      selectCrop:  "पीक निवडा",
      selectSeason:"हंगाम निवडा",
      findSeeds:   "बियाणे शोधा",
      searching:   "बियाणे शोधत आहे...",
      recommended: "शिफारस केलेले",
      suitability: "उपयुक्तता",
      yield:       "उत्पादन",
      maturity:    "परिपक्वता",
      seedRate:    "बियाणे दर",
      findDealer:  "विक्रेता शोधा",
      compare:     "तुलना करा",
      share:       "शेअर करा",
      bestChoice:  "सर्वोत्तम निवड",
      noSeeds:     "तुमच्या भागात बियाणे सापडले नाही",
      droughtTol:  "दुष्काळ सहिष्णु",
      heatTol:     "उष्णता सहिष्णु",
      floodTol:    "पूर सहिष्णु",
      coldTol:     "थंडी सहिष्णु",
      diseaseRes:  "रोग प्रतिरोधक",
      approved:    "सरकारी मान्यता",
      days:        "दिवस",
      quintal:     "क्विंटल"
    }
  },

  gu: {
    nav: {
      dashboard:    "ડેશબોર્ડ",
      prices:       "મંડી ભાવ",
      cropDoctor:   "પાક ડૉક્ટર",
      aiChat:       "AI સહાયક",
      weather:      "હવામાન",
      soil:         "માટી",
      advisory:     "પાક સલાહ",
      schemes:      "સરકારી યોજના",
      decision:     "સ્માર્ટ ટૂલ્સ",
      market:       "બજાર માહિતી",
      cropIntel:    "પાક વિજ્ઞાન",
      community:    "ખેડૂત સમુદાય",
      profile:      "પ્રોફાઇલ",
      pricing:      "કિંમત યાદી",
      logout:       "લૉગ આઉટ",
      login:        "લૉગ ઇન",
      register:     "નોંધણી"
    },
    common: {
      loading:      "લોડ થઈ રહ્યું છે...",
      error:        "કંઈક ખોટું થયું",
      retry:        "ફરી પ્રયાસ કરો",
      save:         "સેવ કરો",
      cancel:       "રદ કરો",
      back:         "પાછળ",
      next:         "આગળ",
      done:         "થઈ ગયું",
      yes:          "હા",
      no:           "ના",
      search:       "શોધો",
      filter:       "ફિલ્ટર",
      viewMore:     "વધુ જુઓ",
      close:        "બંધ કરો",
      submit:       "સબમિટ",
      edit:         "ફેરફાર",
      delete:       "કાઢો",
      share:        "શેર કરો",
      copy:         "કૉપિ",
      copied:       "કૉપિ થઈ!",
      helpline:     "સહાય: 1551",
      source:       "સ્ત્રોત",
      expert:       "નિષ્ણાત",
      free:         "મફત",
      paid:         "ચૂકવણી"
    },
    dashboard: {
      greeting:     "નમસ્તે",
      goodMorning:  "સુપ્રભાત",
      goodAfternoon:"નમસ્કાર",
      goodEvening:  "શુભ સાંજ",
      myFarm:       "મારી ખેતી",
      todayPrices:  "આજના મંડી ભાવ",
      weatherAlert: "હવામાન ચેતવણી",
      weeklyTip:    "સાપ્તાહિક સલાહ",
      noData:       "ડેટા લોડ થઈ રહ્યો છે...",
      viewAll:      "બધું જુઓ",
      myAlerts:     "મારી ચેતવણીઓ",
      quickActions: "ઝડપી ક્રિયા"
    },
    chat: {
      title:         "AI સહાયક",
      subtitle:      "ખેતી વિશે ગમે તે પૂછો",
      placeholder:   "ગુજરાતી કે English માં લખો...",
      send:          "મોકલો",
      listening:     "સાંભળી રહ્યો છું...",
      stopListening: "રોકો",
      thinking:      "સાચો ડેટા લાવી રહ્યો છું...",
      welcome:       "નમસ્તે! હું FassalkartAI। પાક, ભાવ, હવામાન — ગમે તે પૂછો.",
      voiceHint:     "માઇક દબાવો અને બોલો। ૩ સેકન્ડ ચૂપ રહ્યા પછી આપોઆપ રોકાઈ જશે।",
      noAutoSend:    "અવાજ રેકોર્ડ થયો. મોકલવા Send દબાવો.",
      quickQ1:       "આજ ઘઉંના ભાવ?",
      quickQ2:       "આ અઠવાડિયે વરસાદ?",
      quickQ3:       "મારા પાકને રોગ લાગ્યો",
      quickQ4:       "ખાતર ક્યારે અને કેટલું?",
      quickQ5:       "PM-KISAN સ્ટેટસ",
      sources:       "ડેટા સ્ત્રોત",
      liveData:      "લાઇવ ડેટા",
      expertKB:      "નિષ્ણાત સલાહ"
    },
    cropDoctor: {
      title:         "પાક ડૉક્ટર",
      subtitle:      "ફોટો લો → તરત નિદાન",
      selectCrop:    "કયો પાક? *",
      selectPart:    "કઈ જગ્યા? *",
      moreInfo:      "વધુ માહિતી? (optional)",
      moreInfoHint:  "ક્યારથી? પહેલા શું કર્યું?",
      camera:        "કૅમેરા",
      gallery:       "ગૅલેરી",
      analyze:       "નિદાન કરો",
      analyzing:     "AI ફોટો જોઈ રહ્યો છે...",
      newPhoto:      "નવો ફોટો",
      share:         "શેર કરો",
      history:       "ગત તપાસ",
      noHistory:     "હજુ કોઈ તપાસ નહીં",
      newDiagnosis:  "નવી તપાસ",
      saved:         "તપાસ સેવ!",
      urgent:        "તાત્કાલિક — આજે જ સારવાર!",
      symptoms:      "લક્ષણો",
      chemical:      "રાસાયણિક સારવાર",
      organic:       "જૈવ સારવાર",
      prevention:    "બચાવ",
      healthy:       "પાક સ્વસ્થ છે!",
      confidence:    "AI ની ખાતરી",
      parts: ["પાંદડું","થડ","મૂળ",
              "ફૂલ","ફળ","બીજ","આખો છોડ"],
      severity: {
        mild:"હળવું", moderate:"મધ્યમ",
        severe:"ગંભીર", critical:"ખૂબ ગંભીર"
      }
    },
    weather: {
      title:    "હવામાન",
      today:    "આજ",
      tomorrow: "કાલ",
      weekly:   "૭ દિવસ અંદાજ",
      rain:     "વરસાદ",
      temp:     "તાપમાન",
      humidity: "ભેજ",
      wind:     "પવન",
      noSpray:  "આજ spray ન કરો — વરસાદ આવશે",
      irrigate: "આ અઠવાડિયે પિયત જરૂરી",
      heatWave: "ગરમી — સવારે/સાંજ પિયત",
      frost:    "ઠંડી — પાક ઢાંકો"
    },
    prices: {
      title:    "મંડી ભાવ",
      today:    "આજનો ભાવ",
      trend:    "વલણ",
      msp:      "MSP (સરકારી ટેકાના ભાવ)",
      aboveMsp: "MSP થી ઉપર",
      belowMsp: "MSP થી નીચે",
      rising:   "વધી રહ્યો",
      falling:  "ઘટી રહ્યો",
      stable:   "સ્થિર",
      sellNow:  "વેચવાનો સારો સમય",
      wait:     "થોડી રાહ જુઓ",
      noData:   "આજનો ભાવ હજુ નથી",
      perQtl:   "પ્રતિ ક્વિન્ટલ",
      weekAvg:  "૭ દિવસ સરેરાશ"
    },
    profile: {
      title:       "મારી પ્રોફાઇલ",
      name:        "પૂરું નામ",
      phone:       "ફોન નંબર",
      language:    "ભાષા",
      state:       "રાજ્ય",
      district:    "જિલ્લો",
      village:     "ગામ",
      landSize:    "જમીનનો આકાર",
      crops:       "મારા પાક",
      soil:        "માટીનો પ્રકાર",
      irrigation:  "પિયતનો પ્રકાર",
      farming:     "ખેતીનો પ્રકાર",
      whatsapp:    "WhatsApp નંબર",
      saveProfile: "પ્રોફાઇલ સેવ",
      saved:       "પ્રોફાઇલ સેવ!",
      changePhoto: "ફોટો બદલો"
    },
    langSelect: {
      title:   "ભાષા પસંદ કરો",
      subtitle:"તમારી પ્રિય ભાષા પસંદ કરો",
      saved:   "ભાષા બદલાઈ!"
    },
    cropIntelligence: {
      title:"પાક બુદ્ધિ", subtitle:"વાસ્તવિક ડેટા • હવામાન સલાહ • AI વિશ્લેષણ",
      calendar:"કૅલેન્ડર", varieties:"જાત", fertilizer:"ખાતર",
      crop:"પાક", sort:"ક્રમ", profitable:"સૌથી નફાકારક", cultivated:"સૌથી લોકપ્રિય", suitable:"ઉચિત",
      duration:"સમયગાળો", days:"દિવસ", seedRate:"બીજ દર", sowingMethod:"વાવણી પદ્ધતિ",
      transplanting:"રોપણ પદ્ધતિ", marketPremium:"બજાર ફાયદો", quality:"ગુણવત્તા",
      diseaseRes:"રોગ પ્રતિકાર:", source:"સ્ત્રોત:", grafts:"રોપ",
      profChip:"💰 સૌથી નફાકારક", cultChip:"🏆 સૌથી વધુ ઉગાડાતો",
      nitrogen:"નાઈટ્રોજન", phosphorus:"ફોસ્ફરસ", potassium:"પોટાશ",
      land:"જમીન", unit:"એકમ", fertTitle:"ખાતર આયોજક",
      fertPrices:"ખાતરની કિંમત (₹/ગૂણ) — વિસ્તાર પ્રમાણે બદલો:",
      npkReq:"NPK જરૂરિયાત", fertBags:"ખાતરના ગૂણ:",
      totalCost:"કુલ ખર્ચ", perAcre:"દર એકર", appSchedule:"ઉપયોગ સૂચિ",
      stageLabel:"તબક્કો", qty:"જથ્થો", bags:"ગૂણ", cost:"ખર્ચ", bagsUnit:"ગૂણ",
      urea:"યુરિયા 50 kg", ureaFull:"યુરિયા (50 kg)", zinc:"ઝિંક 25 kg", zincFull:"ઝિંક સલ્ફેટ (25 kg)",
      now:"અત્યારે", getAnalysis:"FassalkartAI પાસેથી વિશ્લેષણ મેળવો", analyzing:"વિશ્લેષણ ચાલી રહ્યું છે...",
      analysisIn:"વિશ્લેષણ ભાષા:", retry:"ફરી કરો",
      analysisTitle:"FassalkartAI વિશ્લેષણ", liveWeather:"લાઇવ હવામાન",
      byFassalkartAI:"FassalkartAI દ્વારા", acre:"એકર",
      loadingWeather:"હવામાન ડેટા લોડ થઈ રહ્યો છે...", yourLocation:"તમારો વિસ્તાર",
      humidity:"ભેજ", rain:"વરસાદ",
      safeToSpray:"✅ છંટકાવ યોગ્ય છે", avoidSpraying:"❌ છંટકાવ ન કરો",
      allGrowthStages:"તમામ વૃદ્ધિ અવસ્થા", tasks:"કાર્ય —",
      fullYearCalendar:"આખા વર્ષનું કૅલેન્ડર —",
      noCalendar:"નીચે FassalkartAI પાસેથી વિગતવાર પાક કૅલેન્ડર મેળવો.",
      noVarieties:"નીચે FassalkartAI પાસેથી વિગતવાર જાત ભલામણ મેળવો.",
      noFertilizer:"નીચે FassalkartAI પાસેથી વિગતવાર ખાતર યોજના મેળવો.",
      months:["જાન્યુઆરી","ફેબ્રુઆરી","માર્ચ","એપ્રિલ","મે","જૂન","જુલાઈ","ઑગસ્ટ","સપ્ટેમ્બર","ઑક્ટોબર","નવેમ્બર","ડિસેમ્બર"]
    },
    seeds: {
      title:       "શ્રેષ્ઠ બીજ શોધો",
      selectCrop:  "પાક પસંદ કરો",
      selectSeason:"ઋતુ પસંદ કરો",
      findSeeds:   "બીજ શોધો",
      searching:   "બીજ શોધી રહ્યા છીએ...",
      recommended: "ભલામણ કરેલ",
      suitability: "ઉચિતતા",
      yield:       "ઉત્પાદન",
      maturity:    "પાક સમય",
      seedRate:    "બીજ દર",
      findDealer:  "વેપારી શોધો",
      compare:     "સરખામણી",
      share:       "શેર કરો",
      bestChoice:  "શ્રેષ્ઠ પસંદ",
      noSeeds:     "તમારા વિસ્તારમાં બીજ મળ્યા નહીં",
      droughtTol:  "દુષ્કાળ સહન",
      heatTol:     "ગરમી સહન",
      floodTol:    "પૂર સહન",
      coldTol:     "ઠંડી સહન",
      diseaseRes:  "રોગ પ્રતિકારક",
      approved:    "સરકારી માન્ય",
      days:        "દિવસ",
      quintal:     "ક્વિન્ટલ"
    }
  },

  pa: {
    nav: {
      dashboard:    "ਡੈਸ਼ਬੋਰਡ",
      prices:       "ਮੰਡੀ ਭਾਅ",
      cropDoctor:   "ਫ਼ਸਲ ਡਾਕਟਰ",
      aiChat:       "AI ਸਹਾਇਕ",
      weather:      "ਮੌਸਮ",
      soil:         "ਮਿੱਟੀ",
      advisory:     "ਫ਼ਸਲ ਸਲਾਹ",
      schemes:      "ਸਰਕਾਰੀ ਸਕੀਮਾਂ",
      decision:     "ਸਮਾਰਟ ਟੂਲਸ",
      market:       "ਬਾਜ਼ਾਰ ਜਾਣਕਾਰੀ",
      cropIntel:    "ਫ਼ਸਲ ਵਿਗਿਆਨ",
      community:    "ਕਿਸਾਨ ਭਾਈਚਾਰਾ",
      profile:      "ਪ੍ਰੋਫਾਈਲ",
      pricing:      "ਕੀਮਤ ਸੂਚੀ",
      logout:       "ਲੌਗ ਆਉਟ",
      login:        "ਲੌਗ ਇਨ",
      register:     "ਰਜਿਸਟਰ"
    },
    common: {
      loading:      "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
      error:        "ਕੁਝ ਗਲਤ ਹੋਇਆ",
      retry:        "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      save:         "ਸੇਵ ਕਰੋ",
      cancel:       "ਰੱਦ ਕਰੋ",
      back:         "ਵਾਪਸ",
      next:         "ਅੱਗੇ",
      done:         "ਹੋ ਗਿਆ",
      yes:          "ਹਾਂ",
      no:           "ਨਹੀਂ",
      search:       "ਖੋਜੋ",
      filter:       "ਫਿਲਟਰ",
      viewMore:     "ਹੋਰ ਦੇਖੋ",
      close:        "ਬੰਦ ਕਰੋ",
      submit:       "ਜਮ੍ਹਾ ਕਰੋ",
      edit:         "ਬਦਲੋ",
      delete:       "ਹਟਾਓ",
      share:        "ਸ਼ੇਅਰ ਕਰੋ",
      copy:         "ਕਾਪੀ",
      copied:       "ਕਾਪੀ ਹੋਇਆ!",
      helpline:     "ਸਹਾਇਤਾ: 1551",
      source:       "ਸਰੋਤ",
      expert:       "ਮਾਹਰ",
      free:         "ਮੁਫ਼ਤ",
      paid:         "ਭੁਗਤਾਨ"
    },
    dashboard: {
      greeting:     "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ",
      goodMorning:  "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ",
      goodAfternoon:"ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ",
      goodEvening:  "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ",
      myFarm:       "ਮੇਰੀ ਖੇਤੀ",
      todayPrices:  "ਅੱਜ ਦੇ ਮੰਡੀ ਭਾਅ",
      weatherAlert: "ਮੌਸਮ ਅਲਰਟ",
      weeklyTip:    "ਹਫ਼ਤੇਵਾਰ ਸਲਾਹ",
      noData:       "ਡੇਟਾ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
      viewAll:      "ਸਭ ਦੇਖੋ",
      myAlerts:     "ਮੇਰੇ ਅਲਰਟ",
      quickActions: "ਤੁਰੰਤ ਕੰਮ"
    },
    chat: {
      title:         "AI ਸਹਾਇਕ",
      subtitle:      "ਖੇਤੀ ਬਾਰੇ ਕੁਝ ਵੀ ਪੁੱਛੋ",
      placeholder:   "ਪੰਜਾਬੀ ਜਾਂ English ਵਿੱਚ ਲਿਖੋ...",
      send:          "ਭੇਜੋ",
      listening:     "ਸੁਣ ਰਿਹਾ ਹਾਂ...",
      stopListening: "ਰੋਕੋ",
      thinking:      "ਅਸਲ ਡੇਟਾ ਲਿਆ ਰਿਹਾ ਹਾਂ...",
      welcome:       "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ! ਮੈਂ FassalkartAI ਹਾਂ। ਫ਼ਸਲ, ਭਾਅ, ਮੌਸਮ — ਕੁਝ ਵੀ ਪੁੱਛੋ।",
      voiceHint:     "ਮਾਈਕ ਦਬਾਓ ਅਤੇ ਬੋਲੋ। 3 ਸਕਿੰਟ ਚੁੱਪ ਰਹਿਣ ਤੋਂ ਬਾਅਦ ਆਪੇ ਰੁਕੇਗਾ।",
      noAutoSend:    "ਆਵਾਜ਼ ਰਿਕਾਰਡ ਹੋਈ। ਭੇਜਣ ਲਈ Send ਦਬਾਓ।",
      quickQ1:       "ਅੱਜ ਕਣਕ ਦਾ ਭਾਅ?",
      quickQ2:       "ਇਸ ਹਫ਼ਤੇ ਮੀਂਹ ਪਵੇਗਾ?",
      quickQ3:       "ਮੇਰੀ ਫ਼ਸਲ ਨੂੰ ਬਿਮਾਰੀ ਲੱਗੀ",
      quickQ4:       "ਖਾਦ ਕਦੋਂ ਅਤੇ ਕਿੰਨੀ?",
      quickQ5:       "PM-KISAN ਸਥਿਤੀ",
      sources:       "ਡੇਟਾ ਸਰੋਤ",
      liveData:      "ਲਾਈਵ ਡੇਟਾ",
      expertKB:      "ਮਾਹਰ ਸਲਾਹ"
    },
    cropDoctor: {
      title:         "ਫ਼ਸਲ ਡਾਕਟਰ",
      subtitle:      "ਫੋਟੋ ਲਓ → ਤੁਰੰਤ ਪਛਾਣ",
      selectCrop:    "ਕਿਹੜੀ ਫ਼ਸਲ? *",
      selectPart:    "ਕਿਹੜਾ ਹਿੱਸਾ? *",
      moreInfo:      "ਹੋਰ ਦੱਸੋ? (optional)",
      moreInfoHint:  "ਕਦੋਂ ਤੋਂ? ਪਹਿਲਾਂ ਕੀ ਕੀਤਾ?",
      camera:        "ਕੈਮਰਾ",
      gallery:       "ਗੈਲਰੀ",
      analyze:       "ਪਛਾਣ ਕਰੋ",
      analyzing:     "AI ਫੋਟੋ ਦੇਖ ਰਿਹਾ ਹੈ...",
      newPhoto:      "ਨਵੀਂ ਫੋਟੋ",
      share:         "ਸ਼ੇਅਰ",
      history:       "ਪਿਛਲੀਆਂ ਜਾਂਚਾਂ",
      noHistory:     "ਅਜੇ ਕੋਈ ਜਾਂਚ ਨਹੀਂ",
      newDiagnosis:  "ਨਵੀਂ ਜਾਂਚ",
      saved:         "ਜਾਂਚ ਸੇਵ!",
      urgent:        "ਜ਼ਰੂਰੀ — ਅੱਜ ਹੀ ਇਲਾਜ!",
      symptoms:      "ਲੱਛਣ",
      chemical:      "ਰਸਾਇਣਕ ਇਲਾਜ",
      organic:       "ਕੁਦਰਤੀ ਇਲਾਜ",
      prevention:    "ਬਚਾਅ",
      healthy:       "ਫ਼ਸਲ ਤੰਦਰੁਸਤ ਹੈ!",
      confidence:    "AI ਦਾ ਭਰੋਸਾ",
      parts: ["ਪੱਤਾ","ਤਣਾ","ਜੜ੍ਹ",
              "ਫੁੱਲ","ਫਲ","ਬੀਜ","ਪੂਰਾ ਬੂਟਾ"],
      severity: {
        mild:"ਹਲਕਾ", moderate:"ਦਰਮਿਆਨਾ",
        severe:"ਗੰਭੀਰ", critical:"ਬਹੁਤ ਗੰਭੀਰ"
      }
    },
    weather: {
      title:    "ਮੌਸਮ",
      today:    "ਅੱਜ",
      tomorrow: "ਕੱਲ੍ਹ",
      weekly:   "7 ਦਿਨ ਅਨੁਮਾਨ",
      rain:     "ਮੀਂਹ",
      temp:     "ਤਾਪਮਾਨ",
      humidity: "ਨਮੀ",
      wind:     "ਹਵਾ",
      noSpray:  "ਅੱਜ spray ਨਾ ਕਰੋ — ਮੀਂਹ ਆਵੇਗਾ",
      irrigate: "ਇਸ ਹਫ਼ਤੇ ਸਿੰਚਾਈ ਜ਼ਰੂਰੀ",
      heatWave: "ਗਰਮੀ — ਸਵੇਰੇ/ਸ਼ਾਮ ਸਿੰਚਾਈ",
      frost:    "ਠੰਡ — ਫ਼ਸਲ ਢੱਕੋ"
    },
    prices: {
      title:    "ਮੰਡੀ ਭਾਅ",
      today:    "ਅੱਜ ਦਾ ਭਾਅ",
      trend:    "ਰੁਝਾਨ",
      msp:      "MSP (ਸਰਕਾਰੀ ਸਹਾਇਤਾ ਮੁੱਲ)",
      aboveMsp: "MSP ਤੋਂ ਉੱਪਰ",
      belowMsp: "MSP ਤੋਂ ਹੇਠਾਂ",
      rising:   "ਵੱਧ ਰਿਹਾ",
      falling:  "ਘੱਟ ਰਿਹਾ",
      stable:   "ਸਥਿਰ",
      sellNow:  "ਵੇਚਣ ਦਾ ਚੰਗਾ ਸਮਾਂ",
      wait:     "ਥੋੜਾ ਉਡੀਕ ਕਰੋ",
      noData:   "ਅੱਜ ਦਾ ਭਾਅ ਅਜੇ ਨਹੀਂ",
      perQtl:   "ਪ੍ਰਤੀ ਕੁਇੰਟਲ",
      weekAvg:  "7 ਦਿਨ ਔਸਤ"
    },
    profile: {
      title:       "ਮੇਰੀ ਪ੍ਰੋਫਾਈਲ",
      name:        "ਪੂਰਾ ਨਾਮ",
      phone:       "ਫ਼ੋਨ ਨੰਬਰ",
      language:    "ਭਾਸ਼ਾ",
      state:       "ਰਾਜ",
      district:    "ਜ਼ਿਲ੍ਹਾ",
      village:     "ਪਿੰਡ",
      landSize:    "ਜ਼ਮੀਨ ਦਾ ਆਕਾਰ",
      crops:       "ਮੇਰੀਆਂ ਫ਼ਸਲਾਂ",
      soil:        "ਮਿੱਟੀ ਦੀ ਕਿਸਮ",
      irrigation:  "ਸਿੰਚਾਈ ਦੀ ਕਿਸਮ",
      farming:     "ਖੇਤੀ ਦੀ ਕਿਸਮ",
      whatsapp:    "WhatsApp ਨੰਬਰ",
      saveProfile: "ਪ੍ਰੋਫਾਈਲ ਸੇਵ",
      saved:       "ਪ੍ਰੋਫਾਈਲ ਸੇਵ!",
      changePhoto: "ਫੋਟੋ ਬਦਲੋ"
    },
    langSelect: {
      title:   "ਭਾਸ਼ਾ ਚੁਣੋ",
      subtitle:"ਆਪਣੀ ਪਸੰਦੀਦਾ ਭਾਸ਼ਾ ਚੁਣੋ",
      saved:   "ਭਾਸ਼ਾ ਬਦਲ ਗਈ!"
    },
    cropIntelligence: {
      title:"ਫ਼ਸਲ ਵਿਗਿਆਨ", subtitle:"ਅਸਲ ਡੇਟਾ • ਮੌਸਮ ਸਲਾਹ • AI ਵਿਸ਼ਲੇਸ਼ਣ",
      calendar:"ਕੈਲੰਡਰ", varieties:"ਕਿਸਮਾਂ", fertilizer:"ਖਾਦ",
      crop:"ਫ਼ਸਲ", sort:"ਕ੍ਰਮ", profitable:"ਸਭ ਤੋਂ ਲਾਭਕਾਰੀ", cultivated:"ਸਭ ਤੋਂ ਮਸ਼ਹੂਰ", suitable:"ਉਚਿਤ",
      duration:"ਸਮਾਂ", days:"ਦਿਨ", seedRate:"ਬੀਜ ਦਰ", sowingMethod:"ਬਿਜਾਈ ਵਿਧੀ",
      transplanting:"ਪਨੀਰੀ ਵਿਧੀ", marketPremium:"ਬਾਜ਼ਾਰ ਫਾਇਦਾ", quality:"ਗੁਣਵੱਤਾ",
      diseaseRes:"ਰੋਗ ਰੋਧ:", source:"ਸਰੋਤ:", grafts:"ਪਨੀਰੀ",
      profChip:"💰 ਸਭ ਤੋਂ ਲਾਭਕਾਰੀ", cultChip:"🏆 ਸਭ ਤੋਂ ਵੱਧ ਬੀਜੀ",
      nitrogen:"ਨਾਈਟ੍ਰੋਜਨ", phosphorus:"ਫਾਸਫੋਰਸ", potassium:"ਪੋਟਾਸ਼",
      land:"ਜ਼ਮੀਨ", unit:"ਇਕਾਈ", fertTitle:"ਖਾਦ ਯੋਜਨਾਕਾਰ",
      fertPrices:"ਖਾਦ ਕੀਮਤਾਂ (₹/ਬੋਰੀ) — ਆਪਣੇ ਖੇਤਰ ਅਨੁਸਾਰ ਬਦਲੋ:",
      npkReq:"NPK ਲੋੜਾਂ", fertBags:"ਖਾਦ ਦੀਆਂ ਬੋਰੀਆਂ:",
      totalCost:"ਕੁੱਲ ਖਰਚਾ", perAcre:"ਪ੍ਰਤੀ ਏਕੜ", appSchedule:"ਵਰਤੋਂ ਕਾਰਜਕ੍ਰਮ",
      stageLabel:"ਪੜਾਅ", qty:"ਮਾਤਰਾ", bags:"ਬੋਰੀਆਂ", cost:"ਖਰਚਾ", bagsUnit:"ਬੋਰੀਆਂ",
      urea:"ਯੂਰੀਆ 50 kg", ureaFull:"ਯੂਰੀਆ (50 kg)", zinc:"ਜ਼ਿੰਕ 25 kg", zincFull:"ਜ਼ਿੰਕ ਸਲਫੇਟ (25 kg)",
      now:"ਹੁਣ", getAnalysis:"FassalkartAI ਤੋਂ ਵਿਸ਼ਲੇਸ਼ਣ ਲਓ", analyzing:"ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ...",
      analysisIn:"ਵਿਸ਼ਲੇਸ਼ਣ ਭਾਸ਼ਾ:", retry:"ਦੁਬਾਰਾ",
      analysisTitle:"FassalkartAI ਵਿਸ਼ਲੇਸ਼ਣ", liveWeather:"ਲਾਈਵ ਮੌਸਮ",
      byFassalkartAI:"FassalkartAI ਦੁਆਰਾ", acre:"ਏਕੜ",
      loadingWeather:"ਮੌਸਮ ਡੇਟਾ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...", yourLocation:"ਤੁਹਾਡਾ ਖੇਤਰ",
      humidity:"ਨਮੀ", rain:"ਬਾਰਿਸ਼",
      safeToSpray:"✅ ਸਪ੍ਰੇ ਕਰਨਾ ਸੁਰੱਖਿਅਤ ਹੈ", avoidSpraying:"❌ ਸਪ੍ਰੇ ਨਾ ਕਰੋ",
      allGrowthStages:"ਸਾਰੀਆਂ ਵਿਕਾਸ ਅਵਸਥਾਵਾਂ", tasks:"ਕੰਮ —",
      fullYearCalendar:"ਪੂਰੇ ਸਾਲ ਦਾ ਕੈਲੰਡਰ —",
      noCalendar:"ਹੇਠਾਂ FassalkartAI ਤੋਂ ਵਿਸਥਾਰਿਤ ਫ਼ਸਲ ਕੈਲੰਡਰ ਲਓ।",
      noVarieties:"ਹੇਠਾਂ FassalkartAI ਤੋਂ ਵਿਸਥਾਰਿਤ ਕਿਸਮ ਸਿਫਾਰਸ਼ ਲਓ।",
      noFertilizer:"ਹੇਠਾਂ FassalkartAI ਤੋਂ ਵਿਸਥਾਰਿਤ ਖਾਦ ਯੋਜਨਾ ਲਓ।",
      months:["ਜਨਵਰੀ","ਫਰਵਰੀ","ਮਾਰਚ","ਅਪ੍ਰੈਲ","ਮਈ","ਜੂਨ","ਜੁਲਾਈ","ਅਗਸਤ","ਸਤੰਬਰ","ਅਕਤੂਬਰ","ਨਵੰਬਰ","ਦਸੰਬਰ"]
    },
    seeds: {
      title:       "ਸਭ ਤੋਂ ਵਧੀਆ ਬੀਜ ਲੱਭੋ",
      selectCrop:  "ਫ਼ਸਲ ਚੁਣੋ",
      selectSeason:"ਮੌਸਮ ਚੁਣੋ",
      findSeeds:   "ਬੀਜ ਲੱਭੋ",
      searching:   "ਬੀਜ ਲੱਭ ਰਹੇ ਹਾਂ...",
      recommended: "ਸਿਫਾਰਸ਼ੀ",
      suitability: "ਉਚਿਤਤਾ",
      yield:       "ਝਾੜ",
      maturity:    "ਪੱਕਣ ਦਾ ਸਮਾਂ",
      seedRate:    "ਬੀਜ ਦਰ",
      findDealer:  "ਵਿਕ੍ਰੇਤਾ ਲੱਭੋ",
      compare:     "ਤੁਲਨਾ",
      share:       "ਸ਼ੇਅਰ",
      bestChoice:  "ਸਭ ਤੋਂ ਵਧੀਆ",
      noSeeds:     "ਤੁਹਾਡੇ ਖੇਤਰ ਵਿੱਚ ਬੀਜ ਨਹੀਂ ਮਿਲੇ",
      droughtTol:  "ਸੋਕਾ ਸਹਿਣਸ਼ੀਲ",
      heatTol:     "ਗਰਮੀ ਸਹਿਣਸ਼ੀਲ",
      floodTol:    "ਹੜ੍ਹ ਸਹਿਣਸ਼ੀਲ",
      coldTol:     "ਠੰਡ ਸਹਿਣਸ਼ੀਲ",
      diseaseRes:  "ਰੋਗ ਰੋਧੀ",
      approved:    "ਸਰਕਾਰੀ ਮਨਜ਼ੂਰ",
      days:        "ਦਿਨ",
      quintal:     "ਕੁਇੰਟਲ"
    }
  },

  ta: {
    nav: {
      dashboard:"டாஷ்போர்டு", prices:"சந்தை விலை",
      cropDoctor:"பயிர் மருத்துவர்", aiChat:"AI உதவியாளர்",
      weather:"வானிலை", soil:"மண்",
      advisory:"பயிர் ஆலோசனை", schemes:"அரசு திட்டங்கள்",
      decision:"ஸ்மார்ட் கருவிகள்", market:"சந்தை தகவல்",
      cropIntel:"பயிர் அறிவியல்", community:"விவசாயி சமூகம்",
      profile:"சுயவிவரம்", pricing:"விலை பட்டியல்",
      logout:"வெளியேறு", login:"உள்நுழை", register:"பதிவு"
    },
    common: {
      loading:"ஏற்றுகிறது...", error:"ஏதோ தவறு நடந்தது",
      retry:"மீண்டும் முயற்சி", save:"சேமி", cancel:"ரத்து",
      back:"பின்", next:"முன்", done:"முடிந்தது",
      yes:"ஆம்", no:"இல்லை", search:"தேடு",
      filter:"வடிகட்டு", viewMore:"மேலும் காண்",
      close:"மூடு", submit:"சமர்ப்பி", edit:"திருத்து",
      delete:"நீக்கு", share:"பகிர்", copy:"நகல்",
      copied:"நகல் எடுக்கப்பட்டது!", helpline:"உதவி: 1551",
      source:"மூலம்", expert:"நிபுணர்",
      free:"இலவசம்", paid:"கட்டண"
    },
    dashboard: {
      greeting:"வணக்கம்", goodMorning:"காலை வணக்கம்",
      goodAfternoon:"மதிய வணக்கம்", goodEvening:"மாலை வணக்கம்",
      myFarm:"என் வயல்", todayPrices:"இன்றைய சந்தை விலை",
      weatherAlert:"வானிலை எச்சரிக்கை", weeklyTip:"வார ஆலோசனை",
      noData:"தரவு ஏற்றுகிறது...", viewAll:"அனைத்தும் காண்",
      myAlerts:"என் எச்சரிக்கைகள்", quickActions:"விரைவு செயல்கள்"
    },
    chat: {
      title:"AI உதவியாளர்", subtitle:"விவசாயம் பற்றி எதுவும் கேளுங்கள்",
      placeholder:"தமிழ் அல்லது English இல் எழுதுங்கள்...",
      send:"அனுப்பு", listening:"கேட்கிறேன்...",
      stopListening:"நிறுத்து", thinking:"உண்மையான தரவு கொண்டு வருகிறேன்...",
      welcome:"வணக்கம்! நான் FassalkartAI. பயிர், விலை, வானிலை — எதுவும் கேளுங்கள்.",
      voiceHint:"மைக்கை அழுத்தி பேசுங்கள். 3 வினாடி அமைதியாக இருந்தால் தானாக நிற்கும்.",
      noAutoSend:"குரல் பதிவு ஆயிற்று. அனுப்ப Send அழுத்துங்கள்.",
      quickQ1:"இன்று கோதுமை விலை என்ன?",
      quickQ2:"இந்த வாரம் மழை பெய்யுமா?",
      quickQ3:"என் பயிருக்கு நோய் வந்தது",
      quickQ4:"உரம் எப்போது எவ்வளவு?",
      quickQ5:"PM-KISAN நிலை",
      sources:"தரவு மூலங்கள்", liveData:"நேரடி தரவு",
      expertKB:"நிபுணர் ஆலோசனை"
    },
    cropDoctor: {
      title:"பயிர் மருத்துவர்",
      subtitle:"புகைப்படம் எடு → உடனே நோய் கண்டறி",
      selectCrop:"எந்த பயிர்? *", selectPart:"எந்த பாகம்? *",
      moreInfo:"மேலும் விவரம்? (optional)",
      moreInfoHint:"எப்போதிலிருந்து? முன்பு என்ன செய்தீர்கள்?",
      camera:"கேமரா", gallery:"கேலரி",
      analyze:"கண்டறி", analyzing:"AI புகைப்படம் பார்க்கிறது...",
      newPhoto:"புதிய புகைப்படம்", share:"பகிர்",
      history:"முந்தைய பரிசோதனைகள்",
      noHistory:"இன்னும் பரிசோதனை இல்லை",
      newDiagnosis:"புதிய பரிசோதனை",
      saved:"பரிசோதனை சேமிக்கப்பட்டது!",
      urgent:"அவசரம் — இன்றே சிகிச்சை!",
      symptoms:"அறிகுறிகள்", chemical:"இரசாயன சிகிச்சை",
      organic:"இயற்கை சிகிச்சை", prevention:"தடுப்பு",
      healthy:"பயிர் ஆரோக்கியமாக உள்ளது!",
      confidence:"AI நம்பிக்கை",
      parts:["இலை","தண்டு","வேர்","பூ","பழம்","விதை","முழு செடி"],
      severity:{mild:"லேசான",moderate:"மிதமான",severe:"கடுமையான",critical:"மிகவும் கடுமையான"}
    },
    weather:{
      title:"வானிலை", today:"இன்று", tomorrow:"நாளை",
      weekly:"7 நாள் முன்னறிவிப்பு", rain:"மழை",
      temp:"வெப்பநிலை", humidity:"ஈரப்பதம்", wind:"காற்று",
      noSpray:"இன்று தெளிக்காதீர்கள் — மழை வரும்",
      irrigate:"இந்த வாரம் நீர்ப்பாசனம் தேவை",
      heatWave:"வெப்பம் — காலை/மாலை நீர் ஊற்றுங்கள்",
      frost:"பனி — பயிரை மூடுங்கள்"
    },
    prices:{
      title:"சந்தை விலை", today:"இன்றைய விலை", trend:"போக்கு",
      msp:"MSP (அரசு ஆதரவு விலை)",
      aboveMsp:"MSP க்கு மேல்", belowMsp:"MSP க்கு கீழ்",
      rising:"உயர்கிறது", falling:"குறைகிறது", stable:"நிலையான",
      sellNow:"விற்க நல்ல நேரம்", wait:"சற்று காத்திருங்கள்",
      noData:"இன்றைய விலை இன்னும் இல்லை",
      perQtl:"ஒரு குவிண்டாலுக்கு", weekAvg:"7 நாள் சராசரி"
    },
    profile:{
      title:"என் சுயவிவரம்", name:"முழு பெயர்", phone:"தொலைபேசி",
      language:"மொழி", state:"மாநிலம்", district:"மாவட்டம்",
      village:"கிராமம்", landSize:"நிலம் அளவு", crops:"என் பயிர்கள்",
      soil:"மண் வகை", irrigation:"நீர்ப்பாசன வகை",
      farming:"விவசாய முறை", whatsapp:"WhatsApp எண்",
      saveProfile:"சுயவிவரம் சேமி", saved:"சுயவிவரம் சேமிக்கப்பட்டது!",
      changePhoto:"புகைப்படம் மாற்று"
    },
    langSelect:{title:"மொழி தேர்ந்தெடுங்கள்",
      subtitle:"உங்கள் விருப்பமான மொழியை தேர்ந்தெடுங்கள்",
      saved:"மொழி மாற்றப்பட்டது!"},
    cropIntelligence:{
      title:"பயிர் நுண்ணறிவு", subtitle:"உண்மை தரவு • வானிலை ஆலோசனை • AI பகுப்பாய்வு",
      calendar:"நாட்காட்டி", varieties:"ரகங்கள்", fertilizer:"உரம்",
      crop:"பயிர்", sort:"வரிசை", profitable:"மிகவும் லாபகரமான", cultivated:"மிகவும் பிரபலமான", suitable:"பொருத்தமான",
      duration:"காலம்", days:"நாள்", seedRate:"விதை அளவு", sowingMethod:"விதைப்பு முறை",
      transplanting:"நடவு முறை", marketPremium:"சந்தை சலுகை", quality:"தரம்",
      diseaseRes:"நோய் எதிர்ப்பு:", source:"மூலம்:", grafts:"நாற்று",
      profChip:"💰 மிகவும் லாபகரமான", cultChip:"🏆 மிகவும் பிரபலமான",
      nitrogen:"நைட்ரஜன்", phosphorus:"பாஸ்பரஸ்", potassium:"பொட்டாஷ்",
      land:"நிலம்", unit:"அலகு", fertTitle:"உர திட்டமிடல்",
      fertPrices:"உர விலை (₹/மூட்டை) — உங்கள் பகுதிக்கு மாற்றவும்:",
      npkReq:"NPK தேவைகள்", fertBags:"உர மூட்டைகள்:",
      totalCost:"மொத்த செலவு", perAcre:"ஏக்கருக்கு", appSchedule:"பயன்படுத்தும் அட்டவணை",
      stageLabel:"நிலை", qty:"அளவு", bags:"மூட்டைகள்", cost:"செலவு", bagsUnit:"மூட்டைகள்",
      urea:"யூரியா 50 kg", ureaFull:"யூரியா (50 kg)", zinc:"ஜிங்க் 25 kg", zincFull:"ஜிங்க் சல்பேட் (25 kg)",
      now:"இப்போது", getAnalysis:"FassalkartAI-ல் இருந்து பகுப்பாய்வு", analyzing:"பகுப்பாய்வு செய்கிறது...",
      analysisIn:"பகுப்பாய்வு மொழி:", retry:"மீண்டும்",
      analysisTitle:"FassalkartAI பகுப்பாய்வு", liveWeather:"நேரடி வானிலை",
      byFassalkartAI:"FassalkartAI மூலம்", acre:"ஏக்கர்",
      loadingWeather:"வானிலை தரவு ஏற்றப்படுகிறது...", yourLocation:"உங்கள் பகுதி",
      humidity:"ஈரப்பதம்", rain:"மழை",
      safeToSpray:"✅ தெளிக்கலாம்", avoidSpraying:"❌ தெளிக்காதீர்கள்",
      allGrowthStages:"அனைத்து வளர்ச்சி நிலைகள்", tasks:"பணிகள் —",
      fullYearCalendar:"ஆண்டு முழு நாட்காட்டி —",
      noCalendar:"கீழே FassalkartAI-ல் இருந்து பயிர் நாட்காட்டி பெறுங்கள்.",
      noVarieties:"கீழே FassalkartAI-ல் இருந்து ரக பரிந்துரை பெறுங்கள்.",
      noFertilizer:"கீழே FassalkartAI-ல் இருந்து உர திட்டம் பெறுங்கள்.",
      months:["ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","மே","ஜூன்","ஜூலை","ஆகஸ்ட்","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்"]
    },
    seeds:{title:"சிறந்த விதை தேடு",selectCrop:"பயிர் தேர்ந்தெடு",selectSeason:"பருவம் தேர்ந்தெடு",findSeeds:"விதை தேடு",searching:"விதை தேடுகிறது...",recommended:"பரிந்துரை",suitability:"பொருத்தம்",yield:"மகசூல்",maturity:"முதிர்ச்சி",seedRate:"விதை அளவு",findDealer:"விற்பனையாளர்",compare:"ஒப்பீடு",share:"பகிர்",bestChoice:"சிறந்த தேர்வு",noSeeds:"உங்கள் பகுதியில் விதை இல்லை",droughtTol:"வறட்சி தாங்கும்",heatTol:"வெப்பம் தாங்கும்",floodTol:"வெள்ளம் தாங்கும்",coldTol:"குளிர் தாங்கும்",diseaseRes:"நோய் எதிர்ப்பு",approved:"அரசு அங்கீகாரம்",days:"நாள்",quintal:"குவிண்டால்"}
  },

  te: {
    nav: {
      dashboard:"డాష్‌బోర్డ్", prices:"మంది ధరలు",
      cropDoctor:"పంట డాక్టర్", aiChat:"AI సహాయకుడు",
      weather:"వాతావరణం", soil:"నేల",
      advisory:"పంట సలహా", schemes:"ప్రభుత్వ పథకాలు",
      decision:"స్మార్ట్ టూల్స్", market:"మార్కెట్ సమాచారం",
      cropIntel:"పంట విజ్ఞానం", community:"రైతు సమాజం",
      profile:"ప్రొఫైల్", pricing:"ధర జాబితా",
      logout:"లాగ్ అవుట్", login:"లాగిన్", register:"నమోదు"
    },
    common: {
      loading:"లోడ్ అవుతోంది...", error:"ఏదో తప్పు జరిగింది",
      retry:"మళ్ళీ ప్రయత్నించండి", save:"సేవ్ చేయండి",
      cancel:"రద్దు", back:"వెనక్కి", next:"ముందుకు",
      done:"అయింది", yes:"అవును", no:"కాదు",
      search:"వెతకండి", filter:"ఫిల్టర్",
      viewMore:"మరింత చూడండి", close:"మూసివేయండి",
      submit:"సమర్పించండి", edit:"సవరించండి",
      delete:"తొలగించండి", share:"పంచుకోండి",
      copy:"కాపీ", copied:"కాపీ అయింది!",
      helpline:"సహాయం: 1551", source:"మూలం",
      expert:"నిపుణుడు", free:"ఉచితం", paid:"చెల్లింపు"
    },
    dashboard: {
      greeting:"నమస్కారం", goodMorning:"శుభోదయం",
      goodAfternoon:"నమస్కారం", goodEvening:"శుభ సాయంత్రం",
      myFarm:"నా పొలం", todayPrices:"నేటి మంది ధరలు",
      weatherAlert:"వాతావరణ హెచ్చరిక", weeklyTip:"వారపు సలహా",
      noData:"డేటా లోడ్ అవుతోంది...", viewAll:"అన్నీ చూడండి",
      myAlerts:"నా హెచ్చరికలు", quickActions:"త్వరిత చర్యలు"
    },
    chat: {
      title:"AI సహాయకుడు",
      subtitle:"వ్యవసాయం గురించి ఏదైనా అడగండి",
      placeholder:"తెలుగు లేదా English లో రాయండి...",
      send:"పంపండి", listening:"వింటున్నాను...",
      stopListening:"ఆపండి",
      thinking:"నిజమైన డేటా తీసుకొస్తున్నాను...",
      welcome:"నమస్కారం! నేను FassalkartAI. పంట, ధర, వాతావరణం — ఏదైనా అడగండి.",
      voiceHint:"మైక్ నొక్కి మాట్లాడండి. 3 సెకన్లు మౌనంగా ఉంటే తానే ఆగుతుంది.",
      noAutoSend:"వాయిస్ రికార్డ్ అయింది. పంపడానికి Send నొక్కండి.",
      quickQ1:"నేడు గోధుమ ధర ఎంత?",
      quickQ2:"ఈ వారం వర్షం వస్తుందా?",
      quickQ3:"నా పంటకు రోగం వచ్చింది",
      quickQ4:"ఎరువు ఎప్పుడు ఎంత వేయాలి?",
      quickQ5:"PM-KISAN స్థితి",
      sources:"డేటా మూలాలు", liveData:"నేరుగా డేటా",
      expertKB:"నిపుణుల సలహా"
    },
    cropDoctor: {
      title:"పంట డాక్టర్",
      subtitle:"ఫోటో తీయండి → వెంటనే రోగ నిర్ధారణ",
      selectCrop:"ఏ పంట? *", selectPart:"ఏ భాగం? *",
      moreInfo:"ఇంకా వివరాలు? (optional)",
      moreInfoHint:"ఎన్ని రోజుల నుండి? ముందు ఏం చేశారు?",
      camera:"కెమెరా", gallery:"గ్యాలరీ",
      analyze:"నిర్ధారించండి",
      analyzing:"AI ఫోటో చూస్తోంది...",
      newPhoto:"కొత్త ఫోటో", share:"పంచుకోండి",
      history:"గత పరీక్షలు", noHistory:"ఇంకా పరీక్ష లేదు",
      newDiagnosis:"కొత్త పరీక్ష",
      saved:"పరీక్ష సేవ్ అయింది!",
      urgent:"అత్యవసరం — నేడే చికిత్స!",
      symptoms:"లక్షణాలు", chemical:"రసాయన చికిత్స",
      organic:"సేంద్రీయ చికిత్స", prevention:"నివారణ",
      healthy:"పంట ఆరోగ్యంగా ఉంది!",
      confidence:"AI నమ్మకం",
      parts:["ఆకు","కాండం","వేరు","పువ్వు","పండు","విత్తనం","మొత్తం మొక్క"],
      severity:{mild:"తేలికపాటి",moderate:"మధ్యస్థ",severe:"తీవ్రమైన",critical:"మిక్కిలి తీవ్రమైన"}
    },
    weather:{
      title:"వాతావరణం", today:"నేడు", tomorrow:"రేపు",
      weekly:"7 రోజుల అంచనా", rain:"వర్షం",
      temp:"ఉష్ణోగ్రత", humidity:"తేమ", wind:"గాలి",
      noSpray:"నేడు స్ప్రే చేయకండి — వర్షం వస్తుంది",
      irrigate:"ఈ వారం నీరు పోయడం అవసరం",
      heatWave:"వేడి — ఉదయం/సాయంత్రం నీరు",
      frost:"మంచు — పంటను కప్పండి"
    },
    prices:{
      title:"మంది ధరలు", today:"నేటి ధర", trend:"ధోరణి",
      msp:"MSP (ప్రభుత్వ మద్దతు ధర)",
      aboveMsp:"MSP కంటే ఎక్కువ", belowMsp:"MSP కంటే తక్కువ",
      rising:"పెరుగుతోంది", falling:"తగ్గుతోంది", stable:"స్థిరంగా",
      sellNow:"అమ్మడానికి మంచి సమయం",
      wait:"కొంచెం వేచి ఉండండి",
      noData:"నేటి ధర ఇంకా రాలేదు",
      perQtl:"క్వింటాల్‌కు", weekAvg:"7 రోజుల సగటు"
    },
    profile:{
      title:"నా ప్రొఫైల్", name:"పూర్తి పేరు",
      phone:"ఫోన్ నంబర్", language:"భాష",
      state:"రాష్ట్రం", district:"జిల్లా",
      village:"గ్రామం", landSize:"భూమి పరిమాణం",
      crops:"నా పంటలు", soil:"నేల రకం",
      irrigation:"నీటిపారుదల రకం",
      farming:"వ్యవసాయ పద్ధతి",
      whatsapp:"WhatsApp నంబర్",
      saveProfile:"ప్రొఫైల్ సేవ్",
      saved:"ప్రొఫైల్ సేవ్ అయింది!",
      changePhoto:"ఫోటో మార్చండి"
    },
    langSelect:{title:"భాష ఎంచుకోండి",
      subtitle:"మీకు ఇష్టమైన భాషను ఎంచుకోండి",
      saved:"భాష మార్చబడింది!"},
    cropIntelligence:{
      title:"పంట తెలివి", subtitle:"నిజమైన డేటా • వాతావరణ సలహా • AI విశ్లేషణ",
      calendar:"క్యాలెండర్", varieties:"రకాలు", fertilizer:"ఎరువు",
      crop:"పంట", sort:"క్రమం", profitable:"అత్యంత లాభదాయక", cultivated:"అత్యంత ప్రాచుర్యం", suitable:"అనుకూలమైన",
      duration:"వ్యవధి", days:"రోజులు", seedRate:"విత్తన రేటు", sowingMethod:"విత్తన పద్ధతి",
      transplanting:"నాటే పద్ధతి", marketPremium:"మార్కెట్ ప్రయోజనం", quality:"నాణ్యత",
      diseaseRes:"వ్యాధి నిరోధకత:", source:"మూలం:", grafts:"నారు",
      profChip:"💰 అత్యంత లాభదాయక", cultChip:"🏆 అత్యంత ప్రాచుర్యం",
      nitrogen:"నత్రజని", phosphorus:"భాస్వరం", potassium:"పొటాష్",
      land:"భూమి", unit:"యూనిట్", fertTitle:"ఎరువు ప్రణాళిక",
      fertPrices:"ఎరువు ధరలు (₹/బస్తా) — మీ ప్రాంతానికి మార్చండి:",
      npkReq:"NPK అవసరాలు", fertBags:"ఎరువు బస్తాలు:",
      totalCost:"మొత్తం ఖర్చు", perAcre:"ఎకరాకు", appSchedule:"వేసే సమయపట్టిక",
      stageLabel:"దశ", qty:"మొత్తం", bags:"బస్తాలు", cost:"ఖర్చు", bagsUnit:"బస్తాలు",
      urea:"యూరియా 50 kg", ureaFull:"యూరియా (50 kg)", zinc:"జింక్ 25 kg", zincFull:"జింక్ సల్ఫేట్ (25 kg)",
      now:"ఇప్పుడు", getAnalysis:"FassalkartAI నుండి విశ్లేషణ", analyzing:"విశ్లేషిస్తున్నది...",
      analysisIn:"విశ్లేషణ భాష:", retry:"మళ్ళీ",
      analysisTitle:"FassalkartAI విశ్లేషణ", liveWeather:"లైవ్ వాతావరణం",
      byFassalkartAI:"FassalkartAI ద్వారా", acre:"ఎకరా",
      loadingWeather:"వాతావరణ సమాచారం లోడవుతోంది...", yourLocation:"మీ ప్రాంతం",
      humidity:"తేమ", rain:"వర్షం",
      safeToSpray:"✅ పిచికారీ చేయవచ్చు", avoidSpraying:"❌ పిచికారీ చేయవద్దు",
      allGrowthStages:"అన్ని వృద్ధి దశలు", tasks:"పనులు —",
      fullYearCalendar:"పూర్తి సంవత్సర క్యాలెండర్ —",
      noCalendar:"దిగువ FassalkartAI నుండి పంట క్యాలెండర్ పొందండి.",
      noVarieties:"దిగువ FassalkartAI నుండి రక సిఫారసు పొందండి.",
      noFertilizer:"దిగువ FassalkartAI నుండి ఎరువు ప్రణాళిక పొందండి.",
      months:["జనవరి","ఫిబ్రవరి","మార్చి","ఏప్రిల్","మే","జూన్","జూలై","ఆగస్టు","సెప్టెంబర్","అక్టోబర్","నవంబర్","డిసెంబర్"]
    },
    seeds:{title:"మంచి విత్తనాలు వెతుకు",selectCrop:"పంట ఎంచుకో",selectSeason:"సీజన్ ఎంచుకో",findSeeds:"విత్తనాలు వెతుకు",searching:"విత్తనాలు వెతుకుతున్నాము...",recommended:"సిఫారసు",suitability:"అనుకూలత",yield:"దిగుబడి",maturity:"పక్వత",seedRate:"విత్తన రేటు",findDealer:"డీలర్ వెతుకు",compare:"పోల్చు",share:"పంచుకో",bestChoice:"అత్యుత్తమ",noSeeds:"మీ ప్రాంతంలో విత్తనాలు లేవు",droughtTol:"వర్షాభావ తాళువు",heatTol:"వేడి తాళువు",floodTol:"వరద తాళువు",coldTol:"చలి తాళువు",diseaseRes:"వ్యాధి నిరోధక",approved:"ప్రభుత్వ అనుమతి",days:"రోజులు",quintal:"క్వింటాల్"}
  },

  kn: {
    nav: {
      dashboard:"ಡ್ಯಾಶ್‌ಬೋರ್ಡ್", prices:"ಮಂಡಿ ಬೆಲೆ",
      cropDoctor:"ಬೆಳೆ ವೈದ್ಯ", aiChat:"AI ಸಹಾಯಕ",
      weather:"ಹವಾಮಾನ", soil:"ಮಣ್ಣು",
      advisory:"ಬೆಳೆ ಸಲಹೆ", schemes:"ಸರ್ಕಾರಿ ಯೋಜನೆ",
      decision:"ಸ್ಮಾರ್ಟ್ ಉಪಕರಣ", market:"ಮಾರುಕಟ್ಟೆ ಮಾಹಿತಿ",
      cropIntel:"ಬೆಳೆ ವಿಜ್ಞಾನ", community:"ರೈತ ಸಮುದಾಯ",
      profile:"ಪ್ರೊಫೈಲ್", pricing:"ಬೆಲೆ ಪಟ್ಟಿ",
      logout:"ಲಾಗ್ ಔಟ್", login:"ಲಾಗಿನ್", register:"ನೋಂದಣಿ"
    },
    common: {
      loading:"ಲೋಡ್ ಆಗುತ್ತಿದೆ...", error:"ಏನೋ ತಪ್ಪಾಯಿತು",
      retry:"ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ", save:"ಸೇವ್ ಮಾಡಿ",
      cancel:"ರದ್ದು", back:"ಹಿಂದೆ", next:"ಮುಂದೆ",
      done:"ಆಯಿತು", yes:"ಹೌದು", no:"ಇಲ್ಲ",
      search:"ಹುಡುಕಿ", filter:"ಫಿಲ್ಟರ್",
      viewMore:"ಹೆಚ್ಚು ನೋಡಿ", close:"ಮುಚ್ಚಿ",
      submit:"ಸಲ್ಲಿಸಿ", edit:"ಬದಲಾಯಿಸಿ",
      delete:"ಅಳಿಸಿ", share:"ಹಂಚಿಕೊಳ್ಳಿ",
      copy:"ನಕಲಿಸಿ", copied:"ನಕಲಿಸಲಾಗಿದೆ!",
      helpline:"ಸಹಾಯ: 1551", source:"ಮೂಲ",
      expert:"ತಜ್ಞ", free:"ಉಚಿತ", paid:"ಪಾವತಿ"
    },
    dashboard: {
      greeting:"ನಮಸ್ಕಾರ", goodMorning:"ಶುಭೋದಯ",
      goodAfternoon:"ನಮಸ್ಕಾರ", goodEvening:"ಶುಭ ಸಂಜೆ",
      myFarm:"ನನ್ನ ಹೊಲ", todayPrices:"ಇಂದಿನ ಮಂಡಿ ಬೆಲೆ",
      weatherAlert:"ಹವಾಮಾನ ಎಚ್ಚರಿಕೆ", weeklyTip:"ವಾರದ ಸಲಹೆ",
      noData:"ಡೇಟಾ ಲೋಡ್ ಆಗುತ್ತಿದೆ...", viewAll:"ಎಲ್ಲ ನೋಡಿ",
      myAlerts:"ನನ್ನ ಎಚ್ಚರಿಕೆ", quickActions:"ತ್ವರಿತ ಕ್ರಿಯೆ"
    },
    chat: {
      title:"AI ಸಹಾಯಕ",
      subtitle:"ಕೃಷಿ ಬಗ್ಗೆ ಏನಾದರೂ ಕೇಳಿ",
      placeholder:"ಕನ್ನಡ ಅಥವಾ English ನಲ್ಲಿ ಬರೆಯಿರಿ...",
      send:"ಕಳುಹಿಸಿ", listening:"ಕೇಳುತ್ತಿದ್ದೇನೆ...",
      stopListening:"ನಿಲ್ಲಿಸಿ",
      thinking:"ನಿಜವಾದ ಡೇಟಾ ತರುತ್ತಿದ್ದೇನೆ...",
      welcome:"ನಮಸ್ಕಾರ! ನಾನು FassalkartAI. ಬೆಳೆ, ಬೆಲೆ, ಹವಾಮಾನ — ಏನಾದರೂ ಕೇಳಿ.",
      voiceHint:"ಮೈಕ್ ಒತ್ತಿ ಮಾತಾಡಿ. 3 ಸೆಕೆಂಡ್ ಮೌನವಾದ ನಂತರ ತಾನಾಗಿ ನಿಲ್ಲುತ್ತದೆ.",
      noAutoSend:"ಧ್ವನಿ ರೆಕಾರ್ಡ್ ಆಯಿತು. ಕಳುಹಿಸಲು Send ಒತ್ತಿ.",
      quickQ1:"ಇಂದು ಗೋಧಿ ಬೆಲೆ?",
      quickQ2:"ಈ ವಾರ ಮಳೆ ಬರುತ್ತದಾ?",
      quickQ3:"ನನ್ನ ಬೆಳೆಗೆ ರೋಗ ಬಂದಿದೆ",
      quickQ4:"ಗೊಬ್ಬರ ಯಾವಾಗ ಎಷ್ಟು?",
      quickQ5:"PM-KISAN ಸ್ಥಿತಿ",
      sources:"ಡೇಟಾ ಮೂಲ", liveData:"ನೇರ ಡೇಟಾ",
      expertKB:"ತಜ್ಞ ಸಲಹೆ"
    },
    cropDoctor: {
      title:"ಬೆಳೆ ವೈದ್ಯ",
      subtitle:"ಫೋಟೋ ತೆಗೆಯಿರಿ → ತಕ್ಷಣ ರೋಗ ಪತ್ತೆ",
      selectCrop:"ಯಾವ ಬೆಳೆ? *", selectPart:"ಯಾವ ಭಾಗ? *",
      moreInfo:"ಹೆಚ್ಚಿನ ವಿವರ? (optional)",
      moreInfoHint:"ಯಾವಾಗಿನಿಂದ? ಮೊದಲು ಏನು ಮಾಡಿದ್ದೀರಿ?",
      camera:"ಕ್ಯಾಮೆರಾ", gallery:"ಗ್ಯಾಲರಿ",
      analyze:"ಪತ್ತೆ ಮಾಡಿ",
      analyzing:"AI ಫೋಟೋ ನೋಡುತ್ತಿದೆ...",
      newPhoto:"ಹೊಸ ಫೋಟೋ", share:"ಹಂಚಿಕೊಳ್ಳಿ",
      history:"ಹಿಂದಿನ ಪರೀಕ್ಷೆ",
      noHistory:"ಇನ್ನೂ ಯಾವ ಪರೀಕ್ಷೆಯಿಲ್ಲ",
      newDiagnosis:"ಹೊಸ ಪರೀಕ್ಷೆ",
      saved:"ಪರೀಕ್ಷೆ ಉಳಿಸಲಾಗಿದೆ!",
      urgent:"ತುರ್ತು — ಇಂದೇ ಚಿಕಿತ್ಸೆ!",
      symptoms:"ಲಕ್ಷಣಗಳು", chemical:"ರಾಸಾಯನಿಕ ಚಿಕಿತ್ಸೆ",
      organic:"ಸಾವಯವ ಚಿಕಿತ್ಸೆ", prevention:"ತಡೆಗಟ್ಟುವಿಕೆ",
      healthy:"ಬೆಳೆ ಆರೋಗ್ಯಕರವಾಗಿದೆ!",
      confidence:"AI ವಿಶ್ವಾಸ",
      parts:["ಎಲೆ","ಕಾಂಡ","ಬೇರು","ಹೂ","ಹಣ್ಣು","ಬೀಜ","ಇಡೀ ಗಿಡ"],
      severity:{mild:"ಸಾಧಾರಣ",moderate:"ಮಧ್ಯಮ",severe:"ತೀವ್ರ",critical:"ಅತಿ ತೀವ್ರ"}
    },
    weather:{
      title:"ಹವಾಮಾನ", today:"ಇಂದು", tomorrow:"ನಾಳೆ",
      weekly:"7 ದಿನದ ಮುನ್ಸೂಚನೆ", rain:"ಮಳೆ",
      temp:"ತಾಪಮಾನ", humidity:"ತೇವಾಂಶ", wind:"ಗಾಳಿ",
      noSpray:"ಇಂದು ಸಿಂಪಡಿಸಬೇಡಿ — ಮಳೆ ಬರುತ್ತದೆ",
      irrigate:"ಈ ವಾರ ನೀರಾವರಿ ಅಗತ್ಯ",
      heatWave:"ಶಾಖ — ಬೆಳಿಗ್ಗೆ/ಸಂಜೆ ನೀರು",
      frost:"ಮಂಜು — ಬೆಳೆ ಮುಚ್ಚಿ"
    },
    prices:{
      title:"ಮಂಡಿ ಬೆಲೆ", today:"ಇಂದಿನ ಬೆಲೆ", trend:"ಪ್ರವೃತ್ತಿ",
      msp:"MSP (ಸರ್ಕಾರಿ ಬೆಂಬಲ ಬೆಲೆ)",
      aboveMsp:"MSP ಗಿಂತ ಹೆಚ್ಚು", belowMsp:"MSP ಗಿಂತ ಕಡಿಮೆ",
      rising:"ಹೆಚ್ಚುತ್ತಿದೆ", falling:"ಕಡಿಮೆಯಾಗುತ್ತಿದೆ",
      stable:"ಸ್ಥಿರ", sellNow:"ಮಾರಾಟಕ್ಕೆ ಒಳ್ಳೆಯ ಸಮಯ",
      wait:"ಸ್ವಲ್ಪ ಕಾಯಿರಿ",
      noData:"ಇಂದಿನ ಬೆಲೆ ಇನ್ನೂ ಬಂದಿಲ್ಲ",
      perQtl:"ಕ್ವಿಂಟಾಲ್‌ಗೆ", weekAvg:"7 ದಿನದ ಸರಾಸರಿ"
    },
    profile:{
      title:"ನನ್ನ ಪ್ರೊಫೈಲ್", name:"ಪೂರ್ಣ ಹೆಸರು",
      phone:"ಫೋನ್ ಸಂಖ್ಯೆ", language:"ಭಾಷೆ",
      state:"ರಾಜ್ಯ", district:"ಜಿಲ್ಲೆ", village:"ಗ್ರಾಮ",
      landSize:"ಜಮೀನಿನ ಗಾತ್ರ", crops:"ನನ್ನ ಬೆಳೆಗಳು",
      soil:"ಮಣ್ಣಿನ ವಿಧ", irrigation:"ನೀರಾವರಿ ವಿಧ",
      farming:"ಕೃಷಿ ವಿಧಾನ", whatsapp:"WhatsApp ಸಂಖ್ಯೆ",
      saveProfile:"ಪ್ರೊಫೈಲ್ ಸೇವ್",
      saved:"ಪ್ರೊಫೈಲ್ ಸೇವ್!", changePhoto:"ಫೋಟೋ ಬದಲಿಸಿ"
    },
    langSelect:{title:"ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ",
      subtitle:"ನಿಮ್ಮ ಇಷ್ಟದ ಭಾಷೆ ಆಯ್ಕೆ ಮಾಡಿ",
      saved:"ಭಾಷೆ ಬದಲಾಯಿತು!"},
    cropIntelligence:{
      title:"ಬೆಳೆ ಬುದ್ಧಿಮತ್ತೆ", subtitle:"ನಿಜವಾದ ಡೇಟಾ • ಹವಾಮಾನ ಸಲಹೆ • AI ವಿಶ್ಲೇಷಣೆ",
      calendar:"ಕ್ಯಾಲೆಂಡರ್", varieties:"ತಳಿಗಳು", fertilizer:"ಗೊಬ್ಬರ",
      crop:"ಬೆಳೆ", sort:"ವರ್ಗ", profitable:"ಅತ್ಯಂತ ಲಾಭದಾಯಕ", cultivated:"ಅತ್ಯಂತ ಜನಪ್ರಿಯ", suitable:"ಸೂಕ್ತ",
      duration:"ಅವಧಿ", days:"ದಿನ", seedRate:"ಬೀಜ ದರ", sowingMethod:"ಬಿತ್ತನೆ ವಿಧಾನ",
      transplanting:"ನಾಟಿ ವಿಧಾನ", marketPremium:"ಮಾರುಕಟ್ಟೆ ಲಾಭ", quality:"ಗುಣಮಟ್ಟ",
      diseaseRes:"ರೋಗ ನಿರೋಧಕ:", source:"ಮೂಲ:", grafts:"ಸಸಿ",
      profChip:"💰 ಅತ್ಯಂತ ಲಾಭದಾಯಕ", cultChip:"🏆 ಅತ್ಯಂತ ಜನಪ್ರಿಯ",
      nitrogen:"ಸಾರಜನಕ", phosphorus:"ರಂಜಕ", potassium:"ಪೊಟಾಷ್",
      land:"ಭೂಮಿ", unit:"ಘಟಕ", fertTitle:"ಗೊಬ್ಬರ ಯೋಜನೆ",
      fertPrices:"ಗೊಬ್ಬರ ಬೆಲೆ (₹/ಚೀಲ) — ನಿಮ್ಮ ಪ್ರದೇಶಕ್ಕೆ ಬದಲಾಯಿಸಿ:",
      npkReq:"NPK ಅವಶ್ಯಕತೆ", fertBags:"ಗೊಬ್ಬರ ಚೀಲ:",
      totalCost:"ಒಟ್ಟು ವೆಚ್ಚ", perAcre:"ಪ್ರತಿ ಎಕರೆ", appSchedule:"ಬಳಕೆ ವೇಳಾಪಟ್ಟಿ",
      stageLabel:"ಹಂತ", qty:"ಪ್ರಮಾಣ", bags:"ಚೀಲ", cost:"ವೆಚ್ಚ", bagsUnit:"ಚೀಲ",
      urea:"ಯೂರಿಯಾ 50 kg", ureaFull:"ಯೂರಿಯಾ (50 kg)", zinc:"ಜಿಂಕ್ 25 kg", zincFull:"ಜಿಂಕ್ ಸಲ್ಫೇಟ್ (25 kg)",
      now:"ಈಗ", getAnalysis:"FassalkartAI ನಿಂದ ವಿಶ್ಲೇಷಣೆ", analyzing:"ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
      analysisIn:"ವಿಶ್ಲೇಷಣೆ ಭಾಷೆ:", retry:"ಮತ್ತೆ",
      analysisTitle:"FassalkartAI ವಿಶ್ಲೇಷಣೆ", liveWeather:"ನೇರ ಹವಾಮಾನ",
      byFassalkartAI:"FassalkartAI ಮೂಲಕ", acre:"ಎಕರೆ",
      loadingWeather:"ಹವಾಮಾನ ಡೇಟಾ ಲೋಡ್ ಆಗುತ್ತಿದೆ...", yourLocation:"ನಿಮ್ಮ ಪ್ರದೇಶ",
      humidity:"ತೇವಾಂಶ", rain:"ಮಳೆ",
      safeToSpray:"✅ ಸಿಂಪರಣೆ ಮಾಡಬಹುದು", avoidSpraying:"❌ ಸಿಂಪರಣೆ ಮಾಡಬೇಡಿ",
      allGrowthStages:"ಎಲ್ಲ ಬೆಳವಣಿಗೆ ಹಂತಗಳು", tasks:"ಕಾರ್ಯಗಳು —",
      fullYearCalendar:"ಪೂರ್ಣ ವರ್ಷದ ಕ್ಯಾಲೆಂಡರ್ —",
      noCalendar:"ಕೆಳಗೆ FassalkartAI ನಿಂದ ಬೆಳೆ ಕ್ಯಾಲೆಂಡರ್ ಪಡೆಯಿರಿ.",
      noVarieties:"ಕೆಳಗೆ FassalkartAI ನಿಂದ ತಳಿ ಶಿಫಾರಸು ಪಡೆಯಿರಿ.",
      noFertilizer:"ಕೆಳಗೆ FassalkartAI ನಿಂದ ಗೊಬ್ಬರ ಯೋಜನೆ ಪಡೆಯಿರಿ.",
      months:["ಜನವರಿ","ಫೆಬ್ರವರಿ","ಮಾರ್ಚ್","ಏಪ್ರಿಲ್","ಮೇ","ಜೂನ್","ಜುಲೈ","ಆಗಸ್ಟ್","ಸೆಪ್ಟೆಂಬರ್","ಅಕ್ಟೋಬರ್","ನವೆಂಬರ್","ಡಿಸೆಂಬರ್"]
    },
    seeds:{title:"ಉತ್ತಮ ಬೀಜ ಹುಡುಕಿ",selectCrop:"ಬೆಳೆ ಆಯ್ಕೆ",selectSeason:"ಋತು ಆಯ್ಕೆ",findSeeds:"ಬೀಜ ಹುಡುಕಿ",searching:"ಬೀಜ ಹುಡುಕಲಾಗುತ್ತಿದೆ...",recommended:"ಶಿಫಾರಸು",suitability:"ಸೂಕ್ತತೆ",yield:"ಇಳುವರಿ",maturity:"ಪ್ರಬುದ್ಧತೆ",seedRate:"ಬೀಜ ದರ",findDealer:"ಮಾರಾಟಗಾರ",compare:"ಹೋಲಿಕೆ",share:"ಹಂಚಿಕೆ",bestChoice:"ಅತ್ಯುತ್ತಮ",noSeeds:"ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ಬೀಜ ಇಲ್ಲ",droughtTol:"ಬರ ಸಹಿಷ್ಣು",heatTol:"ಶಾಖ ಸಹಿಷ್ಣು",floodTol:"ಪ್ರವಾಹ ಸಹಿಷ್ಣು",coldTol:"ಚಳಿ ಸಹಿಷ್ಣು",diseaseRes:"ರೋಗ ನಿರೋಧಕ",approved:"ಸರ್ಕಾರ ಅನುಮೋದಿತ",days:"ದಿನ",quintal:"ಕ್ವಿಂಟಾಲ್"}
  },

  ml: {
    nav: {
      dashboard:"ഡാഷ്‌ബോർഡ്", prices:"മാർക്കറ്റ് വില",
      cropDoctor:"വിള ഡോക്ടർ", aiChat:"AI സഹായി",
      weather:"കാലാവസ്ഥ", soil:"മണ്ണ്",
      advisory:"വിള ഉപദേശം", schemes:"സർക്കാർ പദ്ധതികൾ",
      decision:"സ്മാർട്ട് ടൂൾസ്", market:"വിപണി വിവരം",
      cropIntel:"വിള ശാസ്ത്രം", community:"കർഷക സമൂഹം",
      profile:"പ്രൊഫൈൽ", pricing:"വില പട്ടിക",
      logout:"ലോഗ് ഔട്ട്", login:"ലോഗിൻ", register:"രജിസ്റ്റർ"
    },
    common: {
      loading:"ലോഡ് ആകുന്നു...", error:"എന്തോ തെറ്റ് സംഭവിച്ചു",
      retry:"വീണ്ടും ശ്രമിക്കുക", save:"സേവ് ചെയ്യുക",
      cancel:"റദ്ദാക്കുക", back:"പിന്നോട്ട്", next:"മുന്നോട്ട്",
      done:"കഴിഞ്ഞു", yes:"അതെ", no:"ഇല്ല",
      search:"തിരയുക", filter:"ഫിൽറ്റർ",
      viewMore:"കൂടുതൽ കാണുക", close:"അടയ്ക്കുക",
      submit:"സമർപ്പിക്കുക", edit:"തിരുത്തുക",
      delete:"ഇല്ലാതാക്കുക", share:"പങ്കിടുക",
      copy:"പകർത്തുക", copied:"പകർത്തി!",
      helpline:"സഹായം: 1551", source:"ഉറവിടം",
      expert:"വിദഗ്ധൻ", free:"സൌജന്യം", paid:"പണം"
    },
    dashboard: {
      greeting:"നമസ്കാരം", goodMorning:"സുപ്രഭാതം",
      goodAfternoon:"നമസ്കാരം", goodEvening:"ശുഭ സന്ധ്യ",
      myFarm:"എന്റെ കൃഷി", todayPrices:"ഇന്നത്തെ വില",
      weatherAlert:"കാലാവസ്ഥ മുന്നറിയിപ്പ്",
      weeklyTip:"ആഴ്ചതോറുമുള്ള ഉപദേശം",
      noData:"ഡാറ്റ ലോഡ് ആകുന്നു...",
      viewAll:"എല്ലാം കാണുക",
      myAlerts:"എന്റെ അലേർട്ടുകൾ",
      quickActions:"പ്രധാന കർമ്മങ്ങൾ"
    },
    chat: {
      title:"AI സഹായി",
      subtitle:"കൃഷിയെക്കുറിച്ച് ഏതും ചോദിക്കൂ",
      placeholder:"മലയാളം അല്ലെങ്കിൽ English-ൽ ടൈപ്പ് ചെയ്യൂ...",
      send:"അയക്കുക", listening:"ശ്രദ്ധിക്കുന്നു...",
      stopListening:"നിർത്തുക",
      thinking:"യഥാർത്ഥ ഡാറ്റ കൊണ്ടുവരുന്നു...",
      welcome:"നമസ്കാരം! ഞാൻ FassalkartAI. വിള, വില, കാലാവസ്ഥ — ഏതും ചോദിക്കൂ.",
      voiceHint:"മൈക്ക് അമർത്തി സംസാരിക്കൂ. 3 സെക്കൻഡ് നിശ്ശബ്ദമായാൽ സ്വയം നിർത്തും.",
      noAutoSend:"ശബ്ദം റെക്കോർഡ് ആയി. അയക്കാൻ Send അമർത്തൂ.",
      quickQ1:"ഇന്ന് ഗോതമ്പ് വില?",
      quickQ2:"ഈ ആഴ്ച മഴ ഉണ്ടോ?",
      quickQ3:"എന്റെ വിളക്ക് രോഗം വന്നു",
      quickQ4:"വളം എപ്പോൾ എത്ര?",
      quickQ5:"PM-KISAN സ്ഥിതി",
      sources:"ഡാറ്റ ഉറവിടം", liveData:"തത്സമയ ഡാറ്റ",
      expertKB:"വിദഗ്ദ്ധ ഉപദേശം"
    },
    cropDoctor: {
      title:"വിള ഡോക്ടർ",
      subtitle:"ഫോട്ടോ എടുക്കൂ → ഉടൻ രോഗ നിർണ്ണയം",
      selectCrop:"ഏത് വിള? *", selectPart:"ഏത് ഭാഗം? *",
      moreInfo:"കൂടുതൽ വിവരം? (optional)",
      moreInfoHint:"എന്നു മുതൽ? മുമ്പ് എന്ത് ചെയ്തു?",
      camera:"ക്യാമറ", gallery:"ഗ്യാലറി",
      analyze:"നിർണ്ണയിക്കൂ",
      analyzing:"AI ഫോട്ടോ നോക്കുന്നു...",
      newPhoto:"പുതിയ ഫോട്ടോ", share:"പങ്കിടുക",
      history:"മുൻ പരിശോധനകൾ",
      noHistory:"ഇതുവരെ പരിശോധന ഇല്ല",
      newDiagnosis:"പുതിയ പരിശോധന",
      saved:"പരിശോധന സേവ് ആയി!",
      urgent:"അടിയന്തര — ഇന്ന് തന്നെ ചികിത്സ!",
      symptoms:"ലക്ഷണങ്ങൾ", chemical:"രാസ ചികിത്സ",
      organic:"ജൈവ ചികിത്സ", prevention:"പ്രതിരോധം",
      healthy:"വിള ആരോഗ്യകരമാണ്!",
      confidence:"AI വിശ്വാസ്യത",
      parts:["ഇല","തണ്ട്","വേര്","പൂ","ഫലം","വിത്ത്","മുഴുവൻ ചെടി"],
      severity:{mild:"ലഘു",moderate:"മിതമായ",severe:"ഗുരുതര",critical:"അതിഗുരുതര"}
    },
    weather:{
      title:"കാലാവസ്ഥ", today:"ഇന്ന്", tomorrow:"നാളെ",
      weekly:"7 ദിവസ പ്രവചനം", rain:"മഴ",
      temp:"താപനില", humidity:"ഈർപ്പം", wind:"കാറ്റ്",
      noSpray:"ഇന്ന് സ്പ്രേ ചെയ്യരുത് — മഴ വരും",
      irrigate:"ഈ ആഴ്ച നനയ്ക്കൽ ആവശ്യം",
      heatWave:"ചൂട് — രാവിലെ/വൈകിട്ട് നനയ്ക്കൂ",
      frost:"മഞ്ഞ് — വിള മൂടൂ"
    },
    prices:{
      title:"മാർക്കറ്റ് വില", today:"ഇന്നത്തെ വില",
      trend:"പ്രവണത", msp:"MSP (സർക്കാർ പിന്തുണ വില)",
      aboveMsp:"MSP-ക്ക് മുകളിൽ", belowMsp:"MSP-ക്ക് താഴെ",
      rising:"ഉയരുന്നു", falling:"കുറയുന്നു", stable:"സ്ഥിരം",
      sellNow:"വിൽക്കാൻ നല്ല സമയം",
      wait:"കുറച്ച് കാക്കൂ",
      noData:"ഇന്നത്തെ വില ഇനിയും വന്നിട്ടില്ല",
      perQtl:"ക്വിന്റലിന്", weekAvg:"7 ദിവസ ശരാശരി"
    },
    profile:{
      title:"എന്റെ പ്രൊഫൈൽ", name:"പൂർണ്ണ നാമം",
      phone:"ഫോൺ നമ്പർ", language:"ഭാഷ",
      state:"സംസ്ഥാനം", district:"ജില്ല", village:"ഗ്രാമം",
      landSize:"ഭൂമിയുടെ വലിപ്പം", crops:"എന്റെ വിളകൾ",
      soil:"മണ്ണിന്റെ തരം", irrigation:"ജലസേചന രീതി",
      farming:"കൃഷി രീതി", whatsapp:"WhatsApp നമ്പർ",
      saveProfile:"പ്രൊഫൈൽ സേവ്",
      saved:"പ്രൊഫൈൽ സേവ് ആയി!",
      changePhoto:"ഫോട്ടോ മാറ്റൂ"
    },
    langSelect:{title:"ഭാഷ തിരഞ്ഞെടുക്കൂ",
      subtitle:"നിങ്ങളുടെ ഇഷ്ടപ്പെട്ട ഭാഷ തിരഞ്ഞെടുക്കൂ",
      saved:"ഭാഷ മാറ്റി!"},
    cropIntelligence:{
      title:"വിള ബുദ്ധി", subtitle:"യഥാർഥ ഡേറ്റ • കാലാവസ്ഥ ഉപദേശം • AI വിശകലനം",
      calendar:"കലണ്ടർ", varieties:"ഇനങ്ങൾ", fertilizer:"വളം",
      crop:"വിള", sort:"ക്രമം", profitable:"ഏറ്റവും ലാഭകരം", cultivated:"ഏറ്റവും ജനപ്രിയം", suitable:"അനുയോജ്യം",
      duration:"ദൈർഘ്യം", days:"ദിവസം", seedRate:"വിത്ത് നിരക്ക്", sowingMethod:"വിതയ്ക്കൽ രീതി",
      transplanting:"നടീൽ രീതി", marketPremium:"വിപണി നേട്ടം", quality:"ഗുണനിലവാരം",
      diseaseRes:"രോഗ പ്രതിരോധം:", source:"ഉറവിടം:", grafts:"തൈ",
      profChip:"💰 ഏറ്റവും ലാഭകരം", cultChip:"🏆 ഏറ്റവും ജനപ്രിയം",
      nitrogen:"നൈട്രജൻ", phosphorus:"ഫോസ്ഫറസ്", potassium:"പൊട്ടാഷ്",
      land:"ഭൂമി", unit:"യൂണിറ്റ്", fertTitle:"വള ആസൂത്രണം",
      fertPrices:"വള വില (₹/ചാക്ക്) — നിങ്ങളുടെ പ്രദേശം അനുസരിച്ച് മാറ്റുക:",
      npkReq:"NPK ആവശ്യകത", fertBags:"വള ചാക്കുകൾ:",
      totalCost:"മൊത്തം ചെലവ്", perAcre:"ഒരേക്കറിന്", appSchedule:"പ്രയോഗ ഷെഡ്യൂൾ",
      stageLabel:"ഘട്ടം", qty:"അളവ്", bags:"ചാക്ക്", cost:"ചെലവ്", bagsUnit:"ചാക്ക്",
      urea:"യൂറിയ 50 kg", ureaFull:"യൂറിയ (50 kg)", zinc:"സിങ്ക് 25 kg", zincFull:"സിങ്ക് സൾഫേറ്റ് (25 kg)",
      now:"ഇപ്പോൾ", getAnalysis:"FassalkartAI-ൽ നിന്ന് വിശകലനം", analyzing:"വിശകലനം ചെയ്യുന്നു...",
      analysisIn:"വിശകലന ഭാഷ:", retry:"വീണ്ടും",
      analysisTitle:"FassalkartAI വിശകലനം", liveWeather:"തത്സമയ കാലാവസ്ഥ",
      byFassalkartAI:"FassalkartAI വഴി", acre:"ഏക്കർ",
      loadingWeather:"കാലാവസ്ഥ ഡേറ്റ ലോഡ് ചെയ്യുന്നു...", yourLocation:"നിങ്ങളുടെ പ്രദേശം",
      humidity:"ആർദ്രത", rain:"മഴ",
      safeToSpray:"✅ സ്പ്രേ ചെയ്യാം", avoidSpraying:"❌ സ്പ്രേ ചെയ്യരുത്",
      allGrowthStages:"എല്ലാ വളർച്ചാ ഘട്ടങ്ങൾ", tasks:"ജോലികൾ —",
      fullYearCalendar:"മുഴുവൻ വർഷ കലണ്ടർ —",
      noCalendar:"ചുവടെ FassalkartAI-ൽ നിന്ന് വിള കലണ്ടർ നേടുക.",
      noVarieties:"ചുവടെ FassalkartAI-ൽ നിന്ന് ഇനം ശുപാർശ നേടുക.",
      noFertilizer:"ചുവടെ FassalkartAI-ൽ നിന്ന് വള പദ്ധതി നേടുക.",
      months:["ജനുവരി","ഫെബ്രുവരി","മാർച്ച്","ഏപ്രിൽ","മേയ്","ജൂൺ","ജൂലൈ","ഓഗസ്റ്റ്","സെപ്റ്റംബർ","ഒക്ടോബർ","നവംബർ","ഡിസംബർ"]
    },
    seeds:{title:"മികച്ച വിത്ത് കണ്ടെത്തൂ",selectCrop:"വിള തിരഞ്ഞെടുക്കൂ",selectSeason:"സീസൺ തിരഞ്ഞെടുക്കൂ",findSeeds:"വിത്ത് കണ്ടെത്തൂ",searching:"വിത്ത് തിരയുന്നു...",recommended:"ശുപാർശ",suitability:"അനുയോജ്യത",yield:"വിളവ്",maturity:"പക്വത",seedRate:"വിത്ത് നിരക്ക്",findDealer:"ഡീലർ കണ്ടെത്തൂ",compare:"താരതമ്യം",share:"പങ്കിടുക",bestChoice:"ഏറ്റവും നല്ലത്",noSeeds:"നിങ്ങളുടെ പ്രദേശത്ത് വിത്ത് ലഭ്യമല്ല",droughtTol:"വരൾച്ച സഹനം",heatTol:"ചൂട് സഹനം",floodTol:"വെള്ളപ്പൊക്കം സഹനം",coldTol:"തണുപ്പ് സഹനം",diseaseRes:"രോഗ പ്രതിരോധ",approved:"സർക്കാർ അനുമതി",days:"ദിവസം",quintal:"ക്വിന്റൽ"}
  },

  or: {
    nav:{dashboard:"ଡ୍ୟାଶ୍‌ବୋର୍ଡ",prices:"ମଣ୍ଡି ଦର",cropDoctor:"ଫସଲ ଡାକ୍ତର",aiChat:"AI ସହାୟକ",weather:"ଆବହାୱା",soil:"ମାଟି",advisory:"ଫସଲ ପରାମର୍ଶ",schemes:"ସରକାରୀ ଯୋଜନା",decision:"ସ୍ମାର୍ଟ ଉପକରଣ",market:"ବଜାର ତଥ୍ୟ",cropIntel:"ଫସଲ ବିଜ୍ଞାନ",community:"କୃଷକ ସମାଜ",profile:"ପ୍ରୋଫାଇଲ",pricing:"ମୂଲ୍ୟ ତାଲିକା",logout:"ଲଗ ଆଉଟ",login:"ଲଗ ଇନ",register:"ପଞ୍ଜୀକରଣ"},
    common:{loading:"ଲୋଡ ହେଉଛି...",error:"କିଛି ଭୁଲ ହେଲା",retry:"ପୁଣି ଚେଷ୍ଟା",save:"ସେଭ",cancel:"ବାତିଲ",back:"ପଛକୁ",next:"ଆଗକୁ",done:"ହୋଇଗଲା",yes:"ହଁ",no:"ନା",search:"ଖୋଜ",filter:"ଫିଲ୍ଟର",viewMore:"ଅଧିକ",close:"ବନ୍ଦ",submit:"ଦାଖଲ",edit:"ବଦଳ",delete:"ଲିଭା",share:"ଶେୟାର",copy:"କପି",copied:"କପି ହୋଇଗଲା!",helpline:"ସାହାଯ୍ୟ: 1551",source:"ଉତ୍ସ",expert:"ବିଶେଷଜ୍ଞ",free:"ମାଗଣା",paid:"ଦେୟ"},
    dashboard:{greeting:"ନମସ୍କାର",goodMorning:"ଶୁଭ ସକାଳ",goodAfternoon:"ନମସ୍କାର",goodEvening:"ଶୁଭ ସନ୍ଧ୍ୟା",myFarm:"ମୋ ଚାଷ",todayPrices:"ଆଜିର ଦର",weatherAlert:"ଆବହାୱା ସତର୍କ",weeklyTip:"ସାପ୍ତାହିକ ପରାମର୍ଶ",noData:"ଡାଟା ଲୋଡ...",viewAll:"ସବୁ",myAlerts:"ମୋ ସତର୍କ",quickActions:"ଶୀଘ୍ର"},
    chat:{title:"AI ସହାୟକ",subtitle:"ଚାଷ ବିଷୟରେ ଯାହା ପଚାରନ୍ତୁ",placeholder:"ଓଡ଼ିଆ ବା English ରେ ଲେଖନ୍ତୁ...",send:"ପଠାନ୍ତୁ",listening:"ଶୁଣୁଛି...",stopListening:"ବନ୍ଦ",thinking:"ଆସଲ ଡାଟା ଆଣୁଛି...",welcome:"ନମସ୍କାର! ମୁଁ FassalkartAI। ଫସଲ, ଦର, ଆବହାୱା — ଯାହା ପଚାରନ୍ତୁ।",voiceHint:"ମାଇକ ଦବାନ୍ତୁ ଓ କୁହନ୍ତୁ। 3 ସେକ ଚୁପ ରହିଲେ ନିଜୁ ବନ୍ଦ।",noAutoSend:"ଆବାଜ ରେକର୍ଡ ହୋଇଗଲା। Send ଦବାନ୍ତୁ।",quickQ1:"ଆଜି ଗହମ ଦର?",quickQ2:"ଏ ସପ୍ତାହ ବର୍ଷା?",quickQ3:"ମୋ ଫସଲରେ ରୋଗ",quickQ4:"ସାର କ'ଣ ଦେବି?",quickQ5:"PM-KISAN ସ୍ଥିତି",sources:"ଡାଟା ଉତ୍ସ",liveData:"ଲାଇଭ",expertKB:"ବିଶେଷଜ୍ଞ"},
    cropDoctor:{title:"ଫସଲ ଡାକ୍ତର",subtitle:"ଫଟୋ → ଶୀଘ୍ର ରୋଗ ଜ୍ଞାନ",selectCrop:"କେଉଁ ଫସଲ? *",selectPart:"କେଉଁ ଅଂଶ? *",moreInfo:"ଆଉ କ'ଣ? (optional)",moreInfoHint:"କ'ଣ ଦିନରୁ?",camera:"କ୍ୟାମେରା",gallery:"ଗ୍ୟାଲେରୀ",analyze:"ଜ୍ଞାନ",analyzing:"AI ଫଟୋ ଦେଖୁଛି...",newPhoto:"ନୂଆ ଫଟୋ",share:"ଶେୟାର",history:"ଆଗ ପରୀକ୍ଷା",noHistory:"ପରୀକ୍ଷା ନାହିଁ",newDiagnosis:"ନୂଆ ପରୀକ୍ଷା",saved:"ପରୀକ୍ଷା ସେଭ!",urgent:"ଜରୁରୀ — ଆଜି ଚିକିତ୍ସା!",symptoms:"ଲକ୍ଷଣ",chemical:"ରାସାୟନିକ",organic:"ଜୈବ",prevention:"ସୁରକ୍ଷା",healthy:"ଫସଲ ସୁସ୍ଥ!",confidence:"AI ଭରସା",parts:["ପତ୍ର","ଡାଳ","ଶିକଡ","ଫୁଲ","ଫଳ","ବିହନ","ସଂପୂର୍ଣ ଗଛ"],severity:{mild:"ହାଲୁକା",moderate:"ମଧ୍ୟମ",severe:"ଗୁରୁତ୍ୱ",critical:"ଅତ୍ୟଧିକ"}},
    weather:{title:"ଆବହାୱା",today:"ଆଜି",tomorrow:"କାଲି",weekly:"7 ଦିନ",rain:"ବର୍ଷା",temp:"ତାପ",humidity:"ଆର୍ଦ୍ରତା",wind:"ପବନ",noSpray:"ଆଜି spray ନ",irrigate:"ଜଳସେଚନ",heatWave:"ଗରମ",frost:"ଶୀତ"},
    prices:{title:"ମଣ୍ଡି ଦର",today:"ଆଜିର ଦର",trend:"ଗତି",msp:"MSP",aboveMsp:"MSP ଉପରେ",belowMsp:"MSP ତଳେ",rising:"ବଢ଼ୁଛି",falling:"କମୁଛି",stable:"ସ୍ଥିର",sellNow:"ବିକ୍ରୟ ଭଲ",wait:"ଅପେକ୍ଷା",noData:"ଦର ଆସି ନଥିଲ",perQtl:"ପ୍ରତି କ୍ୱିଣ୍ଟାଲ",weekAvg:"7 ଦିନ"},
    profile:{title:"ମୋ ପ୍ରୋଫାଇଲ",name:"ନାମ",phone:"ଫୋନ",language:"ଭାଷା",state:"ରାଜ୍ୟ",district:"ଜିଲ୍ଲା",village:"ଗ୍ରାମ",landSize:"ଜମି",crops:"ଫସଲ",soil:"ମାଟି",irrigation:"ଜଳ",farming:"ଚାଷ",whatsapp:"WhatsApp",saveProfile:"ସେଭ",saved:"ସେଭ!",changePhoto:"ଫଟୋ"},
    langSelect:{title:"ଭାଷା ବାଛନ୍ତୁ",subtitle:"ଆପଣଙ୍କ ଭାଷା",saved:"ଭାଷା ବଦଳ!"},
    cropIntelligence:{title:"ଫସଲ ବୁଦ୍ଧିମତ୍ତା",subtitle:"ଆସଲ ଡାଟା • ଆବହାୱା ପରାମର୍ଶ • AI ବିଶ୍ଳେଷଣ",calendar:"କ୍ୟାଲେଣ୍ଡର",varieties:"କିସ୍ମ",fertilizer:"ସାର",crop:"ଫସଲ",sort:"କ୍ରମ",profitable:"ସବୁଠାରୁ ଲାଭଜନକ",cultivated:"ସବୁଠାରୁ ଲୋକପ୍ରିୟ",suitable:"ଉପଯୁକ୍ତ",duration:"ସময়",days:"ଦିନ",seedRate:"ବିହନ ହାର",sowingMethod:"ବୁଣିବା ପ୍ରଣାଳୀ",transplanting:"ରୋଇବା ପ୍ରଣାଳୀ",marketPremium:"ବଜାର ଲାଭ",quality:"ଗୁଣ",diseaseRes:"ରୋଗ ପ୍ରତିରୋଧ:",source:"ଉତ୍ସ:",grafts:"ଚାରା",profChip:"💰 ସବୁଠାରୁ ଲାଭଜନକ",cultChip:"🏆 ସବୁଠାରୁ ଲୋକପ୍ରିୟ",nitrogen:"ନାଇଟ୍ରୋଜେନ",phosphorus:"ଫସ୍ଫରସ",potassium:"ପୋଟାଶ",land:"ଜମି",unit:"ଏକକ",fertTitle:"ସାର ଯୋଜନା",fertPrices:"ସାର ଦର (₹/ବସ୍ତା)",npkReq:"NPK ଆବଶ୍ୟକତା",fertBags:"ସାର ବସ୍ତା:",totalCost:"ମୋଟ ଖର୍ଚ",perAcre:"ଏକର ପ୍ରତି",appSchedule:"ପ୍ରୟୋଗ ଅନୁସୂଚୀ",stageLabel:"ସ୍ତର",qty:"ପରିମାଣ",bags:"ବସ୍ତା",cost:"ଖର୍ଚ",bagsUnit:"ବସ୍ତା",urea:"ୟୁରିଆ 50 kg",ureaFull:"ୟୁରିଆ (50 kg)",zinc:"ଜିଙ୍କ 25 kg",zincFull:"ଜିଙ୍କ ସଲ୍ଫେଟ (25 kg)",now:"ଏବେ",getAnalysis:"FassalkartAI ରୁ ବିଶ୍ଳେଷଣ",analyzing:"ବିଶ୍ଳେଷଣ ହେଉଛି...",analysisIn:"ବିଶ୍ଳେଷଣ ଭାଷା:",retry:"ପୁଣି",analysisTitle:"FassalkartAI ବିଶ୍ଳେଷଣ",liveWeather:"ଲାଇଭ ଆବହାୱା",byFassalkartAI:"FassalkartAI ଦ୍ୱାରା",acre:"ଏକର",loadingWeather:"ଆବହାୱା ଡାଟା ଲୋଡ ହେଉଛି...",yourLocation:"ଆପଣଙ୍କ ଅଞ୍ଚଳ",humidity:"ଆର୍ଦ୍ରତା",rain:"ବର୍ଷା",safeToSpray:"✅ ସ୍ପ୍ରେ ଠିକ ଅଛି",avoidSpraying:"❌ ସ୍ପ୍ରେ ନ କରନ୍ତୁ",allGrowthStages:"ସମସ୍ତ ବୃଦ୍ଧି ଅବସ୍ଥା",tasks:"କାର୍ଯ୍ୟ —",fullYearCalendar:"ପୂରା ବର୍ଷ କ୍ୟାଲେଣ୍ଡର —",noCalendar:"FassalkartAI ରୁ ଫସଲ କ୍ୟାଲେଣ୍ଡର ପାଆନ୍ତୁ।",noVarieties:"FassalkartAI ରୁ କିସ୍ମ ସୁପାରିଶ ପାଆନ୍ତୁ।",noFertilizer:"FassalkartAI ରୁ ସାର ଯୋଜନା ପାଆନ୍ତୁ।",months:["ଜାନୁଆରୀ","ଫେବ୍ରୁଆରୀ","ମାର୍ଚ୍ଚ","ଅପ୍ରେଲ","ମଇ","ଜୁନ","ଜୁଲାଇ","ଅଗଷ୍ଟ","ସେପ୍ଟେମ୍ବର","ଅକ୍ଟୋବର","ନଭେମ୍ବର","ଡିସେମ୍ବର"]},seeds:{title:"ସବୁଠୁ ଭଲ ବିହନ",selectCrop:"ଫସଲ ବାଛ",selectSeason:"ଋତୁ ବାଛ",findSeeds:"ବିହନ ଖୋଜ",searching:"ବିହନ ଖୋଜୁଛି...",recommended:"ଅନୁଶଂସିତ",suitability:"ଉପଯୁକ୍ତ",yield:"ଉତ୍ପାଦନ",maturity:"ପ୍ରଡ ସମୟ",seedRate:"ବିହନ ହାର",findDealer:"ଡିଲର ଖୋଜ",compare:"ତୁଳନା",share:"ଶେୟାର",bestChoice:"ସର୍ବୋତ୍ତମ",noSeeds:"ଆପଣଙ୍କ ଅଞ୍ଚଳରେ ବିହନ ନଥିଲ",droughtTol:"ଖରା ସହ",heatTol:"ଗରମ ସହ",floodTol:"ବନ୍ୟା ସହ",coldTol:"ଶୀତ ସହ",diseaseRes:"ରୋଗ ପ୍ରତିରୋଧ",approved:"ସରକାରୀ",days:"ଦିନ",quintal:"କ୍ୱିଣ୍ଟାଲ"}
  },

  ne: {
    nav:{dashboard:"ड्यासबोर्ड",prices:"मण्डी मूल्य",cropDoctor:"बाली डाक्टर",aiChat:"AI सहायक",weather:"मौसम",soil:"माटो",advisory:"बाली सल्लाह",schemes:"सरकारी योजना",decision:"स्मार्ट उपकरण",market:"बजार",cropIntel:"बाली विज्ञान",community:"किसान समुदाय",profile:"प्रोफाइल",pricing:"मूल्य सूची",logout:"लग आउट",login:"लग इन",register:"दर्ता"},
    common:{loading:"लोड हुँदैछ...",error:"केही गल्ती",retry:"फेरि प्रयास",save:"सेव",cancel:"रद्द",back:"पछाडि",next:"अगाडि",done:"भयो",yes:"हजुर",no:"होइन",search:"खोज्नुस्",filter:"फिल्टर",viewMore:"थप",close:"बन्द",submit:"पेश",edit:"सम्पादन",delete:"हटाउनुस्",share:"साझा",copy:"कपी",copied:"कपी भयो!",helpline:"सहायता: 1551",source:"स्रोत",expert:"विशेषज्ञ",free:"निःशुल्क",paid:"शुल्क"},
    dashboard:{greeting:"नमस्ते",goodMorning:"शुभ बिहान",goodAfternoon:"नमस्ते",goodEvening:"शुभ साँझ",myFarm:"मेरो खेत",todayPrices:"आजको मूल्य",weatherAlert:"मौसम सतर्कता",weeklyTip:"साप्ताहिक सल्लाह",noData:"लोड हुँदैछ...",viewAll:"सबै",myAlerts:"मेरा सतर्कता",quickActions:"द्रुत"},
    chat:{title:"AI सहायक",subtitle:"खेतीबारे जे पनि सोध्नुस्",placeholder:"नेपाली वा English मा टाइप गर्नुस्...",send:"पठाउनुस्",listening:"सुनिरहेको छु...",stopListening:"रोक्नुस्",thinking:"वास्तविक डेटा ल्याउँदैछु...",welcome:"नमस्ते! म FassalkartAI। बाली, मूल्य, मौसम — जे पनि सोध्नुस्।",voiceHint:"माइक थिच्नुस् र बोल्नुस्। ३ सेकेन्ड चुप भए आफैं रोकिन्छ।",noAutoSend:"आवाज रेकर्ड भयो। पठाउन Send थिच्नुस्।",quickQ1:"आज गहुँको मूल्य?",quickQ2:"यस हप्ता वर्षा हुन्छ?",quickQ3:"मेरो बालीमा रोग लाग्यो",quickQ4:"मल कहिले र कति?",quickQ5:"PM-KISAN स्थिति",sources:"डेटा स्रोत",liveData:"लाइभ",expertKB:"विशेषज्ञ"},
    cropDoctor:{title:"बाली डाक्टर",subtitle:"फोटो → तुरुन्त रोग पत्ता",selectCrop:"कुन बाली? *",selectPart:"कुन भाग? *",moreInfo:"थप विवरण? (optional)",moreInfoHint:"कहिलेदेखि?",camera:"क्यामेरा",gallery:"ग्यालेरी",analyze:"पत्ता लगाउनुस्",analyzing:"AI फोटो हेर्दैछ...",newPhoto:"नयाँ फोटो",share:"साझा",history:"अघिल्ला",noHistory:"परीक्षण छैन",newDiagnosis:"नयाँ परीक्षण",saved:"परीक्षण सेव!",urgent:"जरुरी — आजै उपचार!",symptoms:"लक्षणहरू",chemical:"रासायनिक",organic:"जैविक",prevention:"रोकथाम",healthy:"बाली स्वस्थ!",confidence:"AI विश्वास",parts:["पात","डाँठ","जरा","फूल","फल","बीउ","पूरो बिरुवा"],severity:{mild:"हल्का",moderate:"मध्यम",severe:"गम्भीर",critical:"अति गम्भीर"}},
    weather:{title:"मौसम",today:"आज",tomorrow:"भोलि",weekly:"७ दिन",rain:"वर्षा",temp:"तापक्रम",humidity:"आर्द्रता",wind:"हावा",noSpray:"आज spray नगर्नुस्",irrigate:"सिंचाइ चाहिन्छ",heatWave:"गर्मी",frost:"हिउँ"},
    prices:{title:"मण्डी मूल्य",today:"आजको मूल्य",trend:"प्रवृत्ति",msp:"MSP",aboveMsp:"MSP भन्दा माथि",belowMsp:"MSP भन्दा तल",rising:"बढ्दैछ",falling:"घट्दैछ",stable:"स्थिर",sellNow:"बेच्न राम्रो",wait:"अलि कुर्नुस्",noData:"मूल्य आएको छैन",perQtl:"प्रति क्विन्टल",weekAvg:"७ दिन औसत"},
    profile:{title:"मेरो प्रोफाइल",name:"पूरा नाम",phone:"फोन",language:"भाषा",state:"प्रदेश",district:"जिल्ला",village:"गाउँ",landSize:"जग्गा",crops:"मेरा बाली",soil:"माटो",irrigation:"सिंचाइ",farming:"खेती",whatsapp:"WhatsApp",saveProfile:"प्रोफाइल सेव",saved:"प्रोफाइल सेव!",changePhoto:"फोटो बदल्नुस्"},
    langSelect:{title:"भाषा छान्नुस्",subtitle:"आफ्नो मनपर्ने भाषा",saved:"भाषा परिवर्तन!"},
    cropIntelligence:{title:"बाली बुद्धिमत्ता",subtitle:"वास्तविक डेटा • मौसम सल्लाह • AI विश्लेषण",calendar:"पात्रो",varieties:"जातहरू",fertilizer:"मल",crop:"बाली",sort:"क्रम",profitable:"सबैभन्दा फाइदाजनक",cultivated:"सबैभन्दा लोकप्रिय",suitable:"उपयुक्त",duration:"अवधि",days:"दिन",seedRate:"बीउ दर",sowingMethod:"बुआइ तरिका",transplanting:"रोपाइ तरिका",marketPremium:"बजार फाइदा",quality:"गुणस्तर",diseaseRes:"रोग प्रतिरोध:",source:"स्रोत:",grafts:"बिरुवा",profChip:"💰 सबैभन्दा फाइदाजनक",cultChip:"🏆 सर्वाधिक खेती",nitrogen:"नाइट्रोजन",phosphorus:"फस्फोरस",potassium:"पोटाश",land:"जग्गा",unit:"एकाइ",fertTitle:"मल योजनाकार",fertPrices:"मल मूल्य (₹/बोरा)",npkReq:"NPK आवश्यकता",fertBags:"मल बोराहरू:",totalCost:"कुल खर्च",perAcre:"प्रति रोपनी",appSchedule:"प्रयोग तालिका",stageLabel:"चरण",qty:"मात्रा",bags:"बोरा",cost:"खर्च",bagsUnit:"बोरा",urea:"युरिया 50 kg",ureaFull:"युरिया (50 kg)",zinc:"जिंक 25 kg",zincFull:"जिंक सल्फेट (25 kg)",now:"अहिले",getAnalysis:"FassalkartAI बाट विश्लेषण",analyzing:"विश्लेषण हुँदैछ...",analysisIn:"विश्लेषण भाषा:",retry:"फेरि",analysisTitle:"FassalkartAI विश्लेषण",liveWeather:"लाइभ मौसम",byFassalkartAI:"FassalkartAI बाट",acre:"रोपनी",loadingWeather:"मौसम डेटा लोड हुँदैछ...",yourLocation:"तपाईंको क्षेत्र",humidity:"आर्द्रता",rain:"वर्षा",safeToSpray:"✅ स्प्रे ठीक छ",avoidSpraying:"❌ स्प्रे नगर्नुस्",allGrowthStages:"सबै वृद्धि अवस्थाहरू",tasks:"काम —",fullYearCalendar:"पूरा वर्षको पात्रो —",noCalendar:"FassalkartAI बाट बाली पात्रो पाउनुस्।",noVarieties:"FassalkartAI बाट जात सिफारिस पाउनुस्।",noFertilizer:"FassalkartAI बाट मल योजना पाउनुस्।",months:["जनवरी","फेब्रुवारी","मार्च","अप्रिल","मे","जुन","जुलाई","अगस्त","सेप्टेम्बर","अक्टुबर","नोभेम्बर","डिसेम्बर"]},seeds:{title:"राम्रो बीउ खोज्नुस्",selectCrop:"बाली छान्नुस्",selectSeason:"मौसम छान्नुस्",findSeeds:"बीउ खोज्नुस्",searching:"बीउ खोजिँदैछ...",recommended:"सिफारिस",suitability:"उपयुक्तता",yield:"उत्पादन",maturity:"परिपक्वता",seedRate:"बीउ दर",findDealer:"विक्रेता खोज्नुस्",compare:"तुलना",share:"साझा",bestChoice:"सर्वोत्तम",noSeeds:"तपाईंको क्षेत्रमा बीउ फेला परेन",droughtTol:"खडेरी सहनशील",heatTol:"गर्मी सहनशील",floodTol:"बाढी सहनशील",coldTol:"चिसो सहनशील",diseaseRes:"रोग प्रतिरोधी",approved:"सरकारी स्वीकृत",days:"दिन",quintal:"क्विन्टल"}
  },

  as: {
    nav:{dashboard:"ডেশ্বব'ৰ্ড",prices:"মণ্ডী দাম",cropDoctor:"শস্য ডাক্তৰ",aiChat:"AI সহায়ক",weather:"বতৰ",soil:"মাটি",advisory:"শস্য পৰামৰ্শ",schemes:"চৰকাৰী আঁচনি",decision:"স্মাৰ্ট সঁজুলি",market:"বজাৰ",cropIntel:"শস্য বিজ্ঞান",community:"কৃষক সমাজ",profile:"প্ৰফাইল",pricing:"মূল্য তালিকা",logout:"লগ আউট",login:"লগ ইন",register:"পঞ্জীয়ন"},
    common:{loading:"লোড হৈছে...",error:"কিবা ভুল",retry:"পুনৰ চেষ্টা",save:"সেভ",cancel:"বাতিল",back:"পিছলৈ",next:"আগলৈ",done:"হ'ল",yes:"হয়",no:"নহয়",search:"বিচাৰক",filter:"ফিল্টাৰ",viewMore:"অধিক",close:"বন্ধ",submit:"দাখিল",edit:"সম্পাদনা",delete:"মচক",share:"শ্বেয়াৰ",copy:"কপি",copied:"কপি হ'ল!",helpline:"সহায়: 1551",source:"উৎস",expert:"বিশেষজ্ঞ",free:"বিনামূলীয়া",paid:"মচলা"},
    dashboard:{greeting:"নমস্কাৰ",goodMorning:"শুভ ৰাতিপুৱা",goodAfternoon:"নমস্কাৰ",goodEvening:"শুভ সন্ধিয়া",myFarm:"মোৰ খেতি",todayPrices:"আজিৰ দাম",weatherAlert:"বতৰ সতৰ্কতা",weeklyTip:"সাপ্তাহিক",noData:"লোড...",viewAll:"সকলো",myAlerts:"মোৰ সতৰ্কতা",quickActions:"দ্ৰুত"},
    chat:{title:"AI সহায়ক",subtitle:"কৃষিৰ বিষয়ে যিকোনো কথা সুধক",placeholder:"অসমীয়া বা English ত লিখক...",send:"পঠাওক",listening:"শুনিছে...",stopListening:"বন্ধ",thinking:"আচল ডেটা আনিছে...",welcome:"নমস্কাৰ! মই FassalkartAI। শস্য, দাম, বতৰ — যিকোনো কথা সুধক।",voiceHint:"মাইক টিপক আৰু ক'ব। ৩ ছেকেণ্ড চুপ থাকিলে নিজেই ৰোধ হ'ব।",noAutoSend:"কথা ৰেকৰ্ড হ'ল। Send টিপক।",quickQ1:"আজি ঘেঁহু দাম?",quickQ2:"এই সপ্তাহত বৰষুণ?",quickQ3:"মোৰ শস্যত ৰোগ লাগিছে",quickQ4:"সাৰ কেতিয়া কিমান?",quickQ5:"PM-KISAN স্থিতি",sources:"ডেটা উৎস",liveData:"লাইভ",expertKB:"বিশেষজ্ঞ"},
    cropDoctor:{title:"শস্য ডাক্তৰ",subtitle:"ফটো → শস্য ৰোগ",selectCrop:"কোনটো শস্য? *",selectPart:"কোনটো অংশ? *",moreInfo:"আৰু তথ্য? (optional)",moreInfoHint:"কেতিয়াৰ পৰা?",camera:"কেমেৰা",gallery:"গেলেৰী",analyze:"চিনাক্ত",analyzing:"AI ফটো চাইছে...",newPhoto:"নতুন ফটো",share:"শ্বেয়াৰ",history:"আগৰ পৰীক্ষা",noHistory:"পৰীক্ষা নাই",newDiagnosis:"নতুন পৰীক্ষা",saved:"পৰীক্ষা সেভ!",urgent:"জৰুৰী — আজিয়েই চিকিৎসা!",symptoms:"লক্ষণ",chemical:"ৰাসায়নিক",organic:"জৈৱিক",prevention:"প্ৰতিৰোধ",healthy:"শস্য স্বাস্থ্যকৰ!",confidence:"AI বিশ্বাস",parts:["পাত","কাণ্ড","শিপা","ফুল","ফল","বীজ","সম্পূৰ্ণ গছ"],severity:{mild:"সামান্য",moderate:"মধ্যম",severe:"গুৰুতৰ",critical:"অতি গুৰুতৰ"}},
    weather:{title:"বতৰ",today:"আজি",tomorrow:"কালি",weekly:"৭ দিন",rain:"বৰষুণ",temp:"উষ্ণতা",humidity:"আৰ্দ্ৰতা",wind:"বতাহ",noSpray:"আজি spray নকৰিব",irrigate:"জলসিঞ্চন লাগিব",heatWave:"গৰম",frost:"হিম"},
    prices:{title:"মণ্ডী দাম",today:"আজিৰ দাম",trend:"প্ৰৱণতা",msp:"MSP",aboveMsp:"MSP তকৈ বেছি",belowMsp:"MSP তকৈ কম",rising:"বাঢ়িছে",falling:"কমিছে",stable:"স্থিৰ",sellNow:"বিক্ৰীৰ ভাল সময়",wait:"অলপ ৰওক",noData:"আজিৰ দাম আহে নাই",perQtl:"প্ৰতি কুইণ্টল",weekAvg:"৭ দিনৰ গড়"},
    profile:{title:"মোৰ প্ৰফাইল",name:"সম্পূৰ্ণ নাম",phone:"ফোন নম্বৰ",language:"ভাষা",state:"ৰাজ্য",district:"জিলা",village:"গাওঁ",landSize:"মাটিৰ পৰিমাণ",crops:"মোৰ শস্য",soil:"মাটিৰ প্ৰকাৰ",irrigation:"জলসিঞ্চন",farming:"কৃষি",whatsapp:"WhatsApp নম্বৰ",saveProfile:"প্ৰফাইল সেভ",saved:"প্ৰফাইল সেভ!",changePhoto:"ফটো সলনি"},
    langSelect:{title:"ভাষা বাছক",subtitle:"আপোনাৰ পছন্দৰ ভাষা",saved:"ভাষা সলনি হ'ল!"},
    cropIntelligence:{title:"শস্য বুদ্ধিমত্তা",subtitle:"আচল তথ্য • বতৰ পৰামৰ্শ • AI বিশ্লেষণ",calendar:"কেলেণ্ডাৰ",varieties:"জাত",fertilizer:"সাৰ",crop:"শস্য",sort:"ক্ৰম",profitable:"আটাইতকৈ লাভজনক",cultivated:"আটাইতকৈ জনপ্ৰিয়",suitable:"উপযুক্ত",duration:"সময়কাল",days:"দিন",seedRate:"বীজৰ পৰিমাণ",sowingMethod:"সিঁচা পদ্ধতি",transplanting:"ৰোপণ পদ্ধতি",marketPremium:"বজাৰ সুবিধা",quality:"গুণগত মান",diseaseRes:"ৰোগ প্ৰতিৰোধ:",source:"উৎস:",grafts:"পুলি",profChip:"💰 আটাইতকৈ লাভজনক",cultChip:"🏆 আটাইতকৈ জনপ্ৰিয়",nitrogen:"নাইট্ৰ'জেন",phosphorus:"ফছফৰাছ",potassium:"পটাছ",land:"মাটি",unit:"একক",fertTitle:"সাৰ পৰিকল্পনাকাৰী",fertPrices:"সাৰৰ দাম (₹/বস্তা)",npkReq:"NPK প্ৰয়োজনীয়তা",fertBags:"সাৰৰ বস্তা:",totalCost:"মুঠ খৰচ",perAcre:"প্ৰতি বিঘা",appSchedule:"প্ৰয়োগ তালিকা",stageLabel:"পৰ্যায়",qty:"পৰিমাণ",bags:"বস্তা",cost:"খৰচ",bagsUnit:"বস্তা",urea:"ইউৰিয়া 50 kg",ureaFull:"ইউৰিয়া (50 kg)",zinc:"জিংক 25 kg",zincFull:"জিংক ছালফেট (25 kg)",now:"এতিয়া",getAnalysis:"FassalkartAI ৰ পৰা বিশ্লেষণ",analyzing:"বিশ্লেষণ হৈছে...",analysisIn:"বিশ্লেষণৰ ভাষা:",retry:"পুনৰ",analysisTitle:"FassalkartAI বিশ্লেষণ",liveWeather:"লাইভ বতৰ",byFassalkartAI:"FassalkartAI দ্বাৰা",acre:"বিঘা",loadingWeather:"বতৰৰ তথ্য লোড হৈছে...",yourLocation:"আপোনাৰ অঞ্চল",humidity:"আৰ্দ্ৰতা",rain:"বৰষুণ",safeToSpray:"✅ স্প্ৰে কৰিব পাৰি",avoidSpraying:"❌ স্প্ৰে নকৰিব",allGrowthStages:"সকলো বৃদ্ধিৰ অৱস্থা",tasks:"কাম —",fullYearCalendar:"গোটেই বছৰৰ কেলেণ্ডাৰ —",noCalendar:"FassalkartAI ৰ পৰা শস্য কেলেণ্ডাৰ পাওক।",noVarieties:"FassalkartAI ৰ পৰা জাত পৰামৰ্শ পাওক।",noFertilizer:"FassalkartAI ৰ পৰা সাৰ পৰিকল্পনা পাওক।",months:["জানুৱাৰী","ফেব্ৰুৱাৰী","মাৰ্চ","এপ্ৰিল","মে","জুন","জুলাই","আগষ্ট","ছেপ্তেম্বৰ","অক্টোবৰ","নৱেম্বৰ","ডিচেম্বৰ"]},seeds:{title:"সৰ্বোত্তম বীজ বিচাৰক",selectCrop:"শস্য বাছক",selectSeason:"বতৰ বাছক",findSeeds:"বীজ বিচাৰক",searching:"বীজ বিচাৰি আছে...",recommended:"পৰামৰ্শ",suitability:"উপযুক্ততা",yield:"উৎপাদন",maturity:"পৰিপক্বতা",seedRate:"বীজৰ পৰিমাণ",findDealer:"বিক্ৰেতা বিচাৰক",compare:"তুলনা",share:"ভাগ কৰক",bestChoice:"সৰ্বোত্তম",noSeeds:"আপোনাৰ অঞ্চলত বীজ পোৱা নগল",droughtTol:"খৰাং সহনশীল",heatTol:"গৰম সহনশীল",floodTol:"বানপানী সহনশীল",coldTol:"ঠাণ্ডা সহনশীল",diseaseRes:"ৰোগ প্ৰতিৰোধী",approved:"চৰকাৰী অনুমোদিত",days:"দিন",quintal:"কুইন্টাল"}
  },

  ur: {
    nav:{dashboard:"ڈیش بورڈ",prices:"منڈی بھاؤ",cropDoctor:"فصل ڈاکٹر",aiChat:"AI مددگار",weather:"موسم",soil:"مٹی",advisory:"فصل مشورہ",schemes:"سرکاری منصوبے",decision:"سمارٹ ٹولز",market:"بازار",cropIntel:"فصل سائنس",community:"کسان برادری",profile:"پروفائل",pricing:"قیمت فہرست",logout:"لاگ آؤٹ",login:"لاگ ان",register:"رجسٹر"},
    common:{loading:"لوڈ ہو رہا ہے...",error:"کچھ غلط ہوا",retry:"دوبارہ کوشش",save:"محفوظ",cancel:"منسوخ",back:"واپس",next:"آگے",done:"ہو گیا",yes:"ہاں",no:"نہیں",search:"تلاش",filter:"فلٹر",viewMore:"مزید",close:"بند",submit:"جمع",edit:"ترمیم",delete:"حذف",share:"شیئر",copy:"کاپی",copied:"کاپی ہو گیا!",helpline:"مدد: 1551",source:"ذریعہ",expert:"ماہر",free:"مفت",paid:"ادائیگی"},
    dashboard:{greeting:"السلام علیکم",goodMorning:"صبح بخیر",goodAfternoon:"السلام علیکم",goodEvening:"شام بخیر",myFarm:"میری کھیتی",todayPrices:"آج کے بھاؤ",weatherAlert:"موسم الرٹ",weeklyTip:"ہفتہ وار مشورہ",noData:"لوڈ ہو رہا ہے...",viewAll:"سب دیکھیں",myAlerts:"میرے الرٹ",quickActions:"فوری کام"},
    chat:{title:"AI مددگار",subtitle:"کھیتی کے بارے میں کچھ بھی پوچھیں",placeholder:"اردو یا English میں لکھیں...",send:"بھیجیں",listening:"سن رہا ہوں...",stopListening:"روکیں",thinking:"اصل ڈیٹا لا رہا ہوں...",welcome:"السلام علیکم! میں FassalkartAI ہوں۔ فصل، بھاؤ، موسم — کچھ بھی پوچھیں۔",voiceHint:"مائک دبائیں اور بولیں۔ ۳ سیکنڈ خاموش رہنے پر خود رک جائے گا۔",noAutoSend:"آواز ریکارڈ ہوئی۔ بھیجنے کے لیے Send دبائیں۔",quickQ1:"آج گندم کا بھاؤ؟",quickQ2:"اس ہفتے بارش ہوگی؟",quickQ3:"میری فصل میں بیماری",quickQ4:"کھاد کب اور کتنی؟",quickQ5:"PM-KISAN حیثیت",sources:"ڈیٹا ذرائع",liveData:"لائیو",expertKB:"ماہر مشورہ"},
    cropDoctor:{title:"فصل ڈاکٹر",subtitle:"تصویر لیں → فوری تشخیص",selectCrop:"کون سی فصل؟ *",selectPart:"کون سا حصہ؟ *",moreInfo:"اور بتائیں؟ (optional)",moreInfoHint:"کب سے؟",camera:"کیمرہ",gallery:"گیلری",analyze:"تشخیص",analyzing:"AI تصویر دیکھ رہا ہے...",newPhoto:"نئی تصویر",share:"شیئر",history:"پچھلی جانچ",noHistory:"ابھی کوئی جانچ نہیں",newDiagnosis:"نئی جانچ",saved:"جانچ محفوظ!",urgent:"فوری — آج ہی علاج!",symptoms:"علامات",chemical:"کیمیائی علاج",organic:"قدرتی علاج",prevention:"بچاؤ",healthy:"فصل صحت مند!",confidence:"AI بھروسہ",parts:["پتہ","تنا","جڑ","پھول","پھل","بیج","پورا پودا"],severity:{mild:"ہلکا",moderate:"درمیانہ",severe:"سنگین",critical:"بہت سنگین"}},
    weather:{title:"موسم",today:"آج",tomorrow:"کل",weekly:"۷ روزہ",rain:"بارش",temp:"درجہ حرارت",humidity:"نمی",wind:"ہوا",noSpray:"آج spray نہ کریں",irrigate:"آبپاشی ضروری",heatWave:"گرمی",frost:"پالہ"},
    prices:{title:"منڈی بھاؤ",today:"آج کا بھاؤ",trend:"رجحان",msp:"MSP",aboveMsp:"MSP سے اوپر",belowMsp:"MSP سے نیچے",rising:"بڑھ رہا",falling:"گر رہا",stable:"مستحکم",sellNow:"بیچنے کا اچھا وقت",wait:"تھوڑا انتظار",noData:"بھاؤ ابھی نہیں آیا",perQtl:"فی کوئنٹل",weekAvg:"۷ روزہ اوسط"},
    profile:{title:"میری پروفائل",name:"پورا نام",phone:"فون نمبر",language:"زبان",state:"ریاست",district:"ضلع",village:"گاؤں",landSize:"زمین",crops:"میری فصلیں",soil:"مٹی",irrigation:"آبپاشی",farming:"کھیتی",whatsapp:"WhatsApp نمبر",saveProfile:"پروفائل محفوظ",saved:"پروفائل محفوظ!",changePhoto:"تصویر بدلیں"},
    langSelect:{title:"زبان منتخب کریں",subtitle:"اپنی پسندیدہ زبان",saved:"زبان تبدیل ہو گئی!"},
    cropIntelligence:{title:"فصل سائنس",subtitle:"اصل ڈیٹا • موسم مشورہ • AI تجزیہ",calendar:"کیلنڈر",varieties:"اقسام",fertilizer:"کھاد",crop:"فصل",sort:"ترتیب",profitable:"سب سے فائدہ مند",cultivated:"سب سے مقبول",suitable:"موزوں",duration:"مدت",days:"دن",seedRate:"بیج کی مقدار",sowingMethod:"بوائی طریقہ",transplanting:"روپائی طریقہ",marketPremium:"بازار فائدہ",quality:"معیار",diseaseRes:"بیماری مزاحمت:",source:"ذریعہ:",grafts:"پودا",profChip:"💰 سب سے فائدہ مند",cultChip:"🏆 سب سے مقبول",nitrogen:"نائٹروجن",phosphorus:"فاسفورس",potassium:"پوٹاش",land:"زمین",unit:"اکائی",fertTitle:"کھاد منصوبہ ساز",fertPrices:"کھاد قیمتیں (₹/بوری)",npkReq:"NPK ضروریات",fertBags:"کھاد بوریاں:",totalCost:"کل لاگت",perAcre:"فی ایکڑ",appSchedule:"استعمال نظام الاوقات",stageLabel:"مرحلہ",qty:"مقدار",bags:"بوریاں",cost:"لاگت",bagsUnit:"بوریاں",urea:"یوریا 50 kg",ureaFull:"یوریا (50 kg)",zinc:"زنک 25 kg",zincFull:"زنک سلفیٹ (25 kg)",now:"ابھی",getAnalysis:"FassalkartAI سے تجزیہ لیں",analyzing:"تجزیہ ہو رہا ہے...",analysisIn:"تجزیہ زبان:",retry:"دوبارہ",analysisTitle:"FassalkartAI تجزیہ",liveWeather:"براہ راست موسم",byFassalkartAI:"FassalkartAI کی طرف سے",acre:"ایکڑ",loadingWeather:"موسم ڈیٹا لوڈ ہو رہا ہے...",yourLocation:"آپ کا علاقہ",humidity:"نمی",rain:"بارش",safeToSpray:"✅ اسپرے ٹھیک ہے",avoidSpraying:"❌ اسپرے نہ کریں",allGrowthStages:"تمام نشوونما مراحل",tasks:"کام —",fullYearCalendar:"پورے سال کا کیلنڈر —",noCalendar:"FassalkartAI سے فصل کیلنڈر حاصل کریں۔",noVarieties:"FassalkartAI سے قسم کی سفارش حاصل کریں۔",noFertilizer:"FassalkartAI سے کھاد منصوبہ حاصل کریں۔",months:["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","ستمبر","اکتوبر","نومبر","دسمبر"]},seeds:{title:"بہترین بیج تلاش کریں",selectCrop:"فصل چنیں",selectSeason:"موسم چنیں",findSeeds:"بیج تلاش کریں",searching:"بیج تلاش ہو رہا ہے...",recommended:"سفارش کردہ",suitability:"موزونیت",yield:"پیداوار",maturity:"پختگی",seedRate:"بیج کی مقدار",findDealer:"ڈیلر تلاش کریں",compare:"موازنہ",share:"شیئر",bestChoice:"بہترین انتخاب",noSeeds:"آپ کے علاقے میں بیج نہیں ملے",droughtTol:"خشک سالی برداشت",heatTol:"گرمی برداشت",floodTol:"سیلاب برداشت",coldTol:"ٹھنڈ برداشت",diseaseRes:"بیماری مزاحم",approved:"سرکاری منظور",days:"دن",quintal:"کوئنٹل"}
  },

  ks: {
    nav:{dashboard:"ڈیش بورڈ",prices:"بازار نرخ",cropDoctor:"فصل ڈاکٹر",aiChat:"AI مددگار",weather:"موسم",soil:"مٹی",advisory:"فصل مشورہ",schemes:"سرکاری منصوبہ",decision:"سمارٹ اوزار",market:"بازار",cropIntel:"فصل علم",community:"کسان برادری",profile:"پروفائل",pricing:"نرخ فہرست",logout:"لاگ آؤٹ",login:"لاگ ان",register:"رجسٹر"},
    common:{loading:"لوڈ گژھان چھ...",error:"غلطی",retry:"دوبارہ کوشش",save:"محفوظ",cancel:"منسوخ",back:"واپس",next:"آگہ",done:"سیٹھ",yes:"ہاں",no:"نہ",search:"لوکھ",filter:"فلٹر",viewMore:"زیادہ",close:"بند",submit:"جمع",edit:"بدلو",delete:"ہٹاوو",share:"شیئر",copy:"کاپی",copied:"کاپی سیٹھ!",helpline:"مدد: 1551",source:"ذریعہ",expert:"ماہر",free:"مفت",paid:"قیمت"},
    dashboard:{greeting:"آداب",goodMorning:"شُبھ سٔویر",goodAfternoon:"آداب",goodEvening:"شُبھ شام",myFarm:"مہ کھیتھ",todayPrices:"اَز نرخ",weatherAlert:"موسم الرٹ",weeklyTip:"ہفتہ وار مشورہ",noData:"لوڈ گژھان...",viewAll:"سب وُچھ",myAlerts:"مہ الرٹ",quickActions:"جلدی"},
    chat:{title:"AI مددگار",subtitle:"کھیتی بارہ کانہہ پوچھو",placeholder:"کٲشُر یا English منز لیکھو...",send:"پیٹھاوو",listening:"سُنان چھس...",stopListening:"روکو",thinking:"اصل ڈیٹا یِوان...",welcome:"آداب! میں FassalkartAI چھس۔ فصل، نرخ، موسم — کانہہ پوچھو۔",voiceHint:"مائک دباوو تہ بولو۔ ۳ سیکنڈ خاموش۔",noAutoSend:"آواز ریکارڈ سیٹھ۔ Send دباوو۔",quickQ1:"اَز گندم نرخ؟",quickQ2:"یہ ہفتہ بارش؟",quickQ3:"مہ فصلس بیماری",quickQ4:"کھاد کیتھہ؟",quickQ5:"PM-KISAN حال",sources:"ڈیٹا ذریعہ",liveData:"لائیو",expertKB:"ماہر"},
    cropDoctor:{title:"فصل ڈاکٹر",subtitle:"تصویر لیو → جلد تشخیص",selectCrop:"کُس فصل؟ *",selectPart:"کُس حصہ؟ *",moreInfo:"مزید؟ (optional)",moreInfoHint:"کہ ہنز؟",camera:"کیمرہ",gallery:"گیلری",analyze:"تشخیص",analyzing:"AI تصویر وُچھان...",newPhoto:"نوَ تصویر",share:"شیئر",history:"پہلہ جانچ",noHistory:"جانچ نہ",newDiagnosis:"نوَ جانچ",saved:"جانچ محفوظ!",urgent:"فوری — اَز علاج!",symptoms:"علامات",chemical:"کیمیائی",organic:"قدرتی",prevention:"بچاوٗ",healthy:"فصل تندرست!",confidence:"AI بھروسہ",parts:["پتر","تانہ","اَزل","پُھل","مٹر","بیج","پورو پُھل"],severity:{mild:"ہلکو",moderate:"درمیانو",severe:"سنگین",critical:"بہت سنگین"}},
    weather:{title:"موسم",today:"اَز",tomorrow:"پگاہ",weekly:"۷ دَن",rain:"ژھول",temp:"گرمی",humidity:"نمی",wind:"وات",noSpray:"اَز spray مہ کرو",irrigate:"سینچائی",heatWave:"گرمی",frost:"پالو"},
    prices:{title:"بازار نرخ",today:"اَز نرخ",trend:"رجحان",msp:"MSP",aboveMsp:"MSP پیٹھ",belowMsp:"MSP تل",rising:"ووتھان",falling:"گژھان",stable:"مستحکم",sellNow:"واٹھ وانٕنہ",wait:"تھوری راتھ",noData:"نرخ نہ آیو",perQtl:"کوئنٹل",weekAvg:"۷ دَن اوسط"},
    profile:{title:"مہ پروفائل",name:"ناو",phone:"فون",language:"زبان",state:"صوبہ",district:"ضلع",village:"گام",landSize:"زمین",crops:"مہ فصل",soil:"مٹی",irrigation:"سینچائی",farming:"کھیتی",whatsapp:"WhatsApp",saveProfile:"محفوظ",saved:"محفوظ!",changePhoto:"تصویر"},
    langSelect:{title:"زبان خیر",subtitle:"اپنی زبان",saved:"زبان بدل سیٹھ!"},
    cropIntelligence:{title:"فصل علم",subtitle:"اصل ڈیٹا • موسم مشورہ • AI تجزیہ",calendar:"کیلنڈر",varieties:"اقسام",fertilizer:"کھاد",crop:"فصل",sort:"ترتیب",profitable:"سب سے فائدہ مند",cultivated:"سب سے مقبول",suitable:"موزوں",duration:"مدت",days:"دن",seedRate:"بیج",sowingMethod:"بوائی",transplanting:"روپائی",marketPremium:"بازار فائدہ",quality:"معیار",diseaseRes:"بیماری:",source:"ذریعہ:",grafts:"پودا",profChip:"💰 سب سے فائدہ مند",cultChip:"🏆 سب سے مقبول",nitrogen:"نائٹروجن",phosphorus:"فاسفورس",potassium:"پوٹاش",land:"زمین",unit:"اکائی",fertTitle:"کھاد منصوبہ",fertPrices:"کھاد قیمتیں (₹/بوری)",npkReq:"NPK",fertBags:"کھاد بوریاں:",totalCost:"کل لاگت",perAcre:"فی کنال",appSchedule:"استعمال",stageLabel:"مرحلہ",qty:"مقدار",bags:"بوریاں",cost:"لاگت",bagsUnit:"بوریاں",urea:"یوریا 50 kg",ureaFull:"یوریا (50 kg)",zinc:"زنک 25 kg",zincFull:"زنک سلفیٹ (25 kg)",now:"ابھی",getAnalysis:"FassalkartAI تجزیہ",analyzing:"تجزیہ...",analysisIn:"زبان:",retry:"دوبارہ",analysisTitle:"FassalkartAI تجزیہ",liveWeather:"براہ راست موسم",byFassalkartAI:"FassalkartAI",acre:"کنال",loadingWeather:"موسم لوڈ...",yourLocation:"آپ کا علاقہ",humidity:"نمی",rain:"بارش",safeToSpray:"✅ اسپرے ٹھیک",avoidSpraying:"❌ اسپرے نہ کریں",allGrowthStages:"تمام مراحل",tasks:"کام —",fullYearCalendar:"پورا سال —",noCalendar:"FassalkartAI فصل کیلنڈر۔",noVarieties:"FassalkartAI قسم سفارش۔",noFertilizer:"FassalkartAI کھاد منصوبہ۔",months:["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","ستمبر","اکتوبر","نومبر","دسمبر"]},seeds:{title:"بہترین بیج لبھو",selectCrop:"فصل چنو",selectSeason:"موسم چنو",findSeeds:"بیج لبھو",searching:"بیج لبھان...",recommended:"تجویز",suitability:"مناسبت",yield:"پیداوار",maturity:"پختگی",seedRate:"بیج",findDealer:"ڈیلر لبھو",compare:"مقابلہ",share:"شیئر",bestChoice:"بہترین",noSeeds:"تہندس علاقس منز بیج نہ ملس",droughtTol:"خشکی",heatTol:"گرمی",floodTol:"سیلاب",coldTol:"سردی",diseaseRes:"بیماری",approved:"سرکاری",days:"دوہ",quintal:"کوئنٹل"}
  },

  mni: {
    nav:{dashboard:"ডেশ্বব'র্ড",prices:"মার্কেট দাম",cropDoctor:"পুম্নমক ডাক্তর",aiChat:"AI শরুক",weather:"ৱারেপ",soil:"লৈতক",advisory:"পুম্নমক থাজা",schemes:"সরকারী লৈবাক",decision:"স্মার্ট কার্য",market:"মার্কেট",cropIntel:"পুম্নমক বিগ্যান",community:"লৈরেম শরুক",profile:"প্রোফাইল",pricing:"দাম তালিকা",logout:"লগ আউট",login:"লগ ইন",register:"রেজিস্টার"},
    common:{loading:"লোড হৌজরে...",error:"অমত্তা চাউখ্রে",retry:"অনৌবা তম্বিরে",save:"সেভ তৌবিরে",cancel:"খন্না",back:"হেংগৎ",next:"ফাওবা",done:"তৌবি",yes:"হয়",no:"নত্তে",search:"থাদোক্কনি",filter:"ফিল্টার",viewMore:"অনৌবা",close:"হেইরে",submit:"পুরকপি",edit:"লৌশিনবিরে",delete:"হেইরে",share:"শেয়ার",copy:"কপি",copied:"কপি তৌখ্রে!",helpline:"শরুক: 1551",source:"মফম",expert:"থমোয়",free:"লৈঙ্গল্লোই",paid:"দাম"},
    dashboard:{greeting:"নমস্কার",goodMorning:"শানাবা শুবহ",goodAfternoon:"নমস্কার",goodEvening:"সাংনাবা শুবহ",myFarm:"ঐগী ইকাই",todayPrices:"হায়েং দাম",weatherAlert:"ৱারেপ অলার্ট",weeklyTip:"হপ্তাগী থাজা",noData:"লোড হৌজরে...",viewAll:"মরম মরম",myAlerts:"ঐগী অলার্ট",quickActions:"থুগাই"},
    chat:{title:"AI শরুক",subtitle:"লৈরেম বারে হেন্না হোৎনরে",placeholder:"মৈতৈলোন বা English অদা লিখরে...",send:"পুরকপি",listening:"চৎলি...",stopListening:"হেইরে",thinking:"মতৌ ডেটা লৌনজরে...",welcome:"নমস্কার! ঐ FassalkartAI — পুম্নমক, দাম, ৱারেপ — মরম মরম হোৎনরে।",voiceHint:"মাইক থম্বিরে অমদি ৱারোই। ৩ সেকেন্ড থাদোক্কনি।",noAutoSend:"শব্দ রেকর্ড তৌখ্রে। Send থম্বিরে।",quickQ1:"হায়েং গোম দাম?",quickQ2:"হপ্তাগী অহানবা য়েং?",quickQ3:"ঐগী পুম্নমকতা অসুক",quickQ4:"সার কদাইদা কচা?",quickQ5:"PM-KISAN হাল",sources:"ডেটা মফম",liveData:"লাইভ",expertKB:"থমোয়"},
    cropDoctor:{title:"পুম্নমক ডাক্তর",subtitle:"ফোটো লৌরে → অসুক হনবা",selectCrop:"কদা পুম্নমক? *",selectPart:"কদা অংশ? *",moreInfo:"অনৌবা মতৌ? (optional)",moreInfoHint:"কদা থোকখিবা?",camera:"ক্যামেরা",gallery:"গ্যালারি",analyze:"থাগৎলে",analyzing:"AI ফোটো উৎলি...",newPhoto:"অনৌবা ফোটো",share:"শেয়ার",history:"আগাংগী তেস্ট",noHistory:"তেস্ট অমাও নত্তে",newDiagnosis:"অনৌবা তেস্ট",saved:"তেস্ট সেভ তৌখ্রে!",urgent:"থুগাই — হায়েং অরুম্ব!",symptoms:"লক্ষণ",chemical:"কেমিকেল অরুম্ব",organic:"ওর্গানিক অরুম্ব",prevention:"হেইননবা",healthy:"পুম্নমক য়াই!",confidence:"AI নিংথম",parts:["মারোম","থেং","ওৎপা","পানিন","ঙাকল","মথৌ","মরম মরম"],severity:{mild:"থুপ্পাল",moderate:"অনিবা",severe:"খারা",critical:"খারা হৌবা"}},
    weather:{title:"ৱারেপ",today:"হায়েং",tomorrow:"হৌজিক্তা",weekly:"৭ নুমিৎ",rain:"য়েং",temp:"তাপমাত্রা",humidity:"ৱাথুক",wind:"লানহীন",noSpray:"হায়েং spray নত্তে",irrigate:"পানি দরকার",heatWave:"য়েকথৎ",frost:"সীকোল"},
    prices:{title:"মার্কেট দাম",today:"হায়েং দাম",trend:"ৱাফম",msp:"MSP",aboveMsp:"MSP তোঙ্গন",belowMsp:"MSP ফাওরকপা",rising:"য়াম হৌরে",falling:"থুম হৌরে",stable:"মংলান্না",sellNow:"ওংকপা মতম",wait:"তিন্নবিরে",noData:"দাম পিরে নত্তে",perQtl:"কুইন্টাল অমাদা",weekAvg:"৭ নুমিৎ"},
    profile:{title:"ঐগী প্রোফাইল",name:"মিংফম",phone:"ফোন নম্বর",language:"লোন",state:"রাজ্য",district:"জিলা",village:"য়ুম্ফম",landSize:"লৈতক মশিং",crops:"ঐগী পুম্নমক",soil:"লৈতক থোক",irrigation:"পানি থোক",farming:"লৈরেম থোক",whatsapp:"WhatsApp নম্বর",saveProfile:"প্রোফাইল সেভ",saved:"প্রোফাইল সেভ তৌখ্রে!",changePhoto:"ফোটো পুথোকপিরে"},
    langSelect:{title:"লোন থাগৎলে",subtitle:"নিংশিংগী লোন",saved:"লোন লৌশিনখ্রে!"},
    cropIntelligence:{title:"পুম্নমক বিগ্যান",subtitle:"মতৌ ডেটা • ৱারেপ থাজা • AI পর্যাং",calendar:"কেলেন্দার",varieties:"থাকখিবা",fertilizer:"সার",crop:"পুম্নমক",sort:"ক্রম",profitable:"থুগাই লাইফম",cultivated:"থুগাই পিরোইবা",suitable:"য়াওনবা",duration:"মতম",days:"নুমিৎ",seedRate:"মথৌ মশিং",sowingMethod:"মপুং ফাবা",transplanting:"পুথোকপা",marketPremium:"মার্কেট লাইফম",quality:"গুণ",diseaseRes:"অসুক হেইননবা:",source:"মফম:",grafts:"মপুং",profChip:"💰 থুগাই লাইফম",cultChip:"🏆 থুগাই পিরোইবা",nitrogen:"নাইট্রোজেন",phosphorus:"ফসফরাস",potassium:"পোটাশ",land:"লৈতক",unit:"একক",fertTitle:"সার ওইনবা",fertPrices:"সার দাম (₹/বস্তা)",npkReq:"NPK দরকার",fertBags:"সার বস্তা:",totalCost:"মরম খরচ",perAcre:"একর অমাদা",appSchedule:"পুথোকপা",stageLabel:"পর্যায়",qty:"মশিং",bags:"বস্তা",cost:"খরচ",bagsUnit:"বস্তা",urea:"ইউরিয়া 50 kg",ureaFull:"ইউরিয়া (50 kg)",zinc:"জিংক 25 kg",zincFull:"জিংক সালফেট (25 kg)",now:"হৌজিকতা",getAnalysis:"FassalkartAI পর্যাং",analyzing:"পর্যাং তৌনজরে...",analysisIn:"লোন:",retry:"অদুগা",analysisTitle:"FassalkartAI পর্যাং",liveWeather:"লাইভ ৱারেপ",byFassalkartAI:"FassalkartAI",acre:"একর",loadingWeather:"ৱারেপ ডেটা লোড...",yourLocation:"নহাক্কী মফম",humidity:"মচানবা",rain:"লাংবন",safeToSpray:"✅ স্প্রে য়াই",avoidSpraying:"❌ স্প্রে তৌদে",allGrowthStages:"মরম পর্যায়",tasks:"তৌবিয়ু —",fullYearCalendar:"মরম চহি কেলেন্দার —",noCalendar:"FassalkartAI পুম্নমক কেলেন্দার।",noVarieties:"FassalkartAI থাকখিবা থাজা।",noFertilizer:"FassalkartAI সার ওইনবা।",months:["জানুয়ারি","ফেব্রুয়ারি","মার্চ","এপ্রিল","মে","জুন","জুলাই","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর"]},seeds:{title:"থুগাই মথৌ লৈ",selectCrop:"পুম্নমক থু",selectSeason:"চহি থু",findSeeds:"মথৌ লৈ",searching:"মথৌ লৈনজরে...",recommended:"থাজা",suitability:"য়াওনবা",yield:"ফল",maturity:"হৌবা",seedRate:"মথৌ মশিং",findDealer:"ডিলার লৈ",compare:"ফেদম",share:"শেয়ার",bestChoice:"থুগাই",noSeeds:"নহাক্কী মফমদা মথৌ অমাইবা",droughtTol:"থামহক",heatTol:"লাংথদোক",floodTol:"ইশিং তৱাইবা",coldTol:"থাং",diseaseRes:"অসুক হেইনবা",approved:"সরকার য়েংখিবা",days:"নুমিৎ",quintal:"কুইন্টাল"}
  }

};

export default T;

// ─── LANGUAGE DEFINITIONS ────────────────────────
// type: "pure" = only that language
// type: "mixed" = that language + English
// baseCode: parent language for UI translations

export const LANGUAGES = [

  // ══ PURE LANGUAGES ══════════════════════════════

  { code:"en",
    name:"English",
    nativeName:"English",
    shortName:"EN",
    flag:"🇬🇧",
    dir:"ltr",
    type:"pure",
    group:"pure"
  },

  { code:"hi",
    name:"Hindi",
    nativeName:"हिंदी",
    shortName:"हि",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"north"
  },

  { code:"bn",
    name:"Bengali",
    nativeName:"বাংলা",
    shortName:"বাং",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"east"
  },

  { code:"mr",
    name:"Marathi",
    nativeName:"मराठी",
    shortName:"मरा",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"west"
  },

  { code:"gu",
    name:"Gujarati",
    nativeName:"ગુજરાતી",
    shortName:"ગુ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"west"
  },

  { code:"pa",
    name:"Punjabi",
    nativeName:"ਪੰਜਾਬੀ",
    shortName:"ਪੰ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"north"
  },

  { code:"ta",
    name:"Tamil",
    nativeName:"தமிழ்",
    shortName:"த",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"south"
  },

  { code:"te",
    name:"Telugu",
    nativeName:"తెలుగు",
    shortName:"తె",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"south"
  },

  { code:"kn",
    name:"Kannada",
    nativeName:"ಕನ್ನಡ",
    shortName:"ಕ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"south"
  },

  { code:"ml",
    name:"Malayalam",
    nativeName:"മലയാളം",
    shortName:"മ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"south"
  },

  { code:"or",
    name:"Odia",
    nativeName:"ଓଡ଼ିଆ",
    shortName:"ଓ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"east"
  },

  { code:"ne",
    name:"Nepali",
    nativeName:"नेपाली",
    shortName:"ने",
    flag:"🇳🇵",
    dir:"ltr",
    type:"pure",
    group:"east"
  },

  { code:"as",
    name:"Assamese",
    nativeName:"অসমীয়া",
    shortName:"অ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"east"
  },

  { code:"ur",
    name:"Urdu",
    nativeName:"اردو",
    shortName:"اردو",
    flag:"🇮🇳",
    dir:"rtl",
    type:"pure",
    group:"north"
  },

  { code:"ks",
    name:"Kashmiri",
    nativeName:"کٲشُر",
    shortName:"کٲ",
    flag:"🇮🇳",
    dir:"rtl",
    type:"pure",
    group:"north"
  },

  { code:"mni",
    name:"Manipuri",
    nativeName:"মৈতৈলোন্",
    shortName:"মৈ",
    flag:"🇮🇳",
    dir:"ltr",
    type:"pure",
    group:"east"
  },

  // ══ MIXED LANGUAGES (Local + English) ═══════════
  // UI uses base language translations
  // AI replies mix local language with English

  { code:"hi-en",
    name:"Hinglish",
    nativeName:"Hinglish",
    shortName:"हि+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"hi",
    mixLabel:"हिंदी + English",
    example:"Aapka wheat ₹2180/q hai. MSP se upar, sell karo!"
  },

  { code:"bn-en",
    name:"Banglish",
    nativeName:"Banglish",
    shortName:"বাং+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"bn",
    mixLabel:"বাংলা + English",
    example:"Aapnar gomer dam ₹2180/q. MSP theke beshi, sell korun!"
  },

  { code:"mr-en",
    name:"Marlish",
    nativeName:"Marlish",
    shortName:"मरा+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"mr",
    mixLabel:"मराठी + English",
    example:"Tumcha gehun ₹2180/q ahe. MSP peksha jast, sell kara!"
  },

  { code:"gu-en",
    name:"Gujlish",
    nativeName:"Gujlish",
    shortName:"ગુ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"gu",
    mixLabel:"ગુજરાતી + English",
    example:"Tamaro ghau ₹2180/q chhe. MSP thi vadhu, sell karo!"
  },

  { code:"pa-en",
    name:"Punglish",
    nativeName:"Punglish",
    shortName:"ਪੰ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"pa",
    mixLabel:"ਪੰਜਾਬੀ + English",
    example:"Tera gehun ₹2180/q hai. MSP ton upar, sell karo!"
  },

  { code:"ta-en",
    name:"Tanglish",
    nativeName:"Tanglish",
    shortName:"த+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"ta",
    mixLabel:"தமிழ் + English",
    example:"Ungal kodhum ₹2180/q irukku. MSP vida adhigam, sell pannunga!"
  },

  { code:"te-en",
    name:"Tenglish",
    nativeName:"Tenglish",
    shortName:"తె+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"te",
    mixLabel:"తెలుగు + English",
    example:"Mee godhuma ₹2180/q undi. MSP kante ekkuva, sell cheyyandi!"
  },

  { code:"kn-en",
    name:"Kanglish",
    nativeName:"Kanglish",
    shortName:"ಕ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"kn",
    mixLabel:"ಕನ್ನಡ + English",
    example:"Nimma godi ₹2180/q ide. MSP ginta hechu, sell madi!"
  },

  { code:"ml-en",
    name:"Manlish",
    nativeName:"Manlish",
    shortName:"മ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"ml",
    mixLabel:"മലയാളം + English",
    example:"Ningalude godhambu ₹2180/q aanu. MSP il ekkuva, sell cheyyuka!"
  },

  { code:"or-en",
    name:"Odlish",
    nativeName:"Odlish",
    shortName:"ଓ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"or",
    mixLabel:"ଓଡ଼ିଆ + English",
    example:"Aapanka gahama ₹2180/q achi. MSP tharu besi, sell karantu!"
  },

  { code:"ne-en",
    name:"Neplish",
    nativeName:"Neplish",
    shortName:"ने+EN",
    flag:"🇳🇵",
    dir:"ltr",
    type:"mixed",
    baseCode:"ne",
    mixLabel:"नेपाली + English",
    example:"Tapainko gahu ₹2180/q chha. MSP bhandha badhi, sell garnus!"
  },

  { code:"as-en",
    name:"Asslish",
    nativeName:"Asslish",
    shortName:"অ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"as",
    mixLabel:"অসমীয়া + English",
    example:"Aapunar ghau ₹2180/q ache. MSP tukoi besi, sell karok!"
  },

  { code:"ur-en",
    name:"Urlish",
    nativeName:"Urlish",
    shortName:"اردو+EN",
    flag:"🇮🇳",
    dir:"rtl",
    type:"mixed",
    baseCode:"ur",
    mixLabel:"اردو + English",
    example:"Aapka gandum ₹2180/q hai. MSP se upar, sell karein!"
  },

  { code:"ks-en",
    name:"Kashlish",
    nativeName:"Kashlish",
    shortName:"کٲ+EN",
    flag:"🇮🇳",
    dir:"rtl",
    type:"mixed",
    baseCode:"ks",
    mixLabel:"کٲشُر + English",
    example:"Tuhund gandum ₹2180/q chhu. MSP than wuchh, sell karav!"
  },

  { code:"mni-en",
    name:"Meitlish",
    nativeName:"Meitlish",
    shortName:"মৈ+EN",
    flag:"🇮🇳",
    dir:"ltr",
    type:"mixed",
    baseCode:"mni",
    mixLabel:"মৈতৈলোন্ + English",
    example:"Nanggi gom ₹2180/q oina. MSP tagi yamna, sell touri!"
  }
];

// ─── Voice codes (pure + mixed) ───────────────────
export const VOICE_CODES = {
  en:"en-IN",   hi:"hi-IN",   bn:"bn-IN",
  mr:"mr-IN",   gu:"gu-IN",   pa:"pa-IN",
  ta:"ta-IN",   te:"te-IN",   kn:"kn-IN",
  ml:"ml-IN",   or:"or-IN",   ne:"ne-NP",
  as:"as-IN",   ur:"ur-IN",   ks:"ur-IN",
  mni:"bn-IN",
  "hi-en":"hi-IN",  "bn-en":"bn-IN",
  "mr-en":"mr-IN",  "gu-en":"gu-IN",
  "pa-en":"pa-IN",  "ta-en":"ta-IN",
  "te-en":"te-IN",  "kn-en":"kn-IN",
  "ml-en":"ml-IN",  "or-en":"or-IN",
  "ne-en":"ne-NP",  "as-en":"as-IN",
  "ur-en":"ur-IN",  "ks-en":"ur-IN",
  "mni-en":"bn-IN"
};

// ─── RTL languages ────────────────────────────────
export const RTL_LANGS =
  new Set(["ur","ks","ur-en","ks-en"]);

// ─── Get base code for mixed modes ────────────────
export const getBaseCode = (code) => {
  const lang = LANGUAGES.find(
    l => l.code === code
  );
  return lang?.baseCode || code;
};

// ─── Get translations for any code ───────────────
// Mixed modes use base language T object for UI
export const getFallback = (code) => {
  const base = getBaseCode(code);
  return T[base] || T[code] || T.en;
};

// ─── Group definitions for dropdown ──────────────
export const LANG_GROUPS = {
  pure: {
    label: "Pure Language",
    subLabel: "Only in that language",
    codes: [
      "en","hi","bn","mr","gu","pa",
      "ta","te","kn","ml","or","ne",
      "as","ur","ks","mni"
    ]
  },
  mixed: {
    label: "Mixed with English",
    subLabel: "Local language + English mix",
    codes: [
      "hi-en","bn-en","mr-en","gu-en",
      "pa-en","ta-en","te-en","kn-en",
      "ml-en","or-en","ne-en","as-en",
      "ur-en","ks-en","mni-en"
    ]
  }
};

// ─── AI instruction per language ─────────────────
export const AI_INSTRUCTION = {

  // PURE — strict single language
  en:
    "Reply ONLY in clear simple English. " +
    "Avoid jargon. Words a farmer understands.",
  hi:
    "Reply ONLY in pure Hindi (Devanagari). " +
    "Simple village-level Hindi. " +
    "Avoid English words unless no Hindi word exists.",
  bn:
    "Reply ONLY in pure Bengali script. " +
    "Simple Bengali a village farmer uses. " +
    "No English words.",
  mr:
    "Reply ONLY in simple Marathi. " +
    "Village Marathi only.",
  gu:
    "Reply ONLY in simple Gujarati. " +
    "Village-level Gujarati.",
  pa:
    "Reply ONLY in Punjabi (Gurmukhi script). " +
    "Simple farming Punjabi.",
  ta:
    "Reply ONLY in simple Tamil. " +
    "Village Tamil. No English words.",
  te:
    "Reply ONLY in simple Telugu. " +
    "Village Telugu only.",
  kn:
    "Reply ONLY in simple Kannada. " +
    "Village Kannada only.",
  ml:
    "Reply ONLY in simple Malayalam. " +
    "Village Malayalam only.",
  or:
    "Reply ONLY in simple Odia. " +
    "Village Odia only.",
  ne:
    "Reply ONLY in simple Nepali. " +
    "Nepal context: NPR currency, " +
    "NARC varieties.",
  as:
    "Reply ONLY in simple Assamese. " +
    "Village Assamese only.",
  ur:
    "Reply ONLY in Urdu script. " +
    "Simple farming Urdu.",
  ks:
    "Reply in Kashmiri. " +
    "Kashmiri + some Urdu is ok.",
  mni:
    "Reply ONLY in simple Manipuri (Meitei). " +
    "No English words.",

  // MIXED — natural code-switching
  "hi-en":
    "Reply in HINGLISH — natural Hindi+English mix. " +
    "Like young Indian farmers talk. " +
    "Example: 'Aapka wheat ₹2180/q hai. " +
    "Yeh MSP se upar hai, sell karna " +
    "advisable hai. Is hafte baarish nahi " +
    "hogi, so spray karo.' " +
    "Roman script ok. Mix naturally. " +
    "Do NOT write full sentences in only Hindi " +
    "or only English.",

  "bn-en":
    "Reply in BANGLISH — Bengali+English mix " +
    "in Roman script. " +
    "Example: 'Aapnar gomer dam ₹2180/q. " +
    "MSP theke beshi, sell korun. " +
    "Ei week-e bristi hobe na, spray koren.' " +
    "Bengali words in Roman letters. " +
    "Natural code-switching.",

  "mr-en":
    "Reply in MARLISH — Marathi+English mix. " +
    "Example: 'Tumcha gehun ₹2180/q ahe. " +
    "MSP peksha jast, sell kara. " +
    "Ya aathavdyat paus nahiye, spray kara.' " +
    "Marathi words in Roman script mixed " +
    "naturally with English.",

  "gu-en":
    "Reply in GUJLISH — Gujarati+English mix. " +
    "Example: 'Tamaro ghau ₹2180/q chhe. " +
    "MSP thi vadhu chhe, sell karo. " +
    "Aa week ma varshad nahi, spray karo.' " +
    "Natural Gujarati-English mix.",

  "pa-en":
    "Reply in PUNGLISH — Punjabi+English mix. " +
    "Example: 'Tera gehun ₹2180/q aa. " +
    "MSP ton upar hai, sell karo. " +
    "Is hafte meenh nahi paiga, spray karo.' " +
    "Natural Punjabi-English mix.",

  "ta-en":
    "Reply in TANGLISH — Tamil+English mix. " +
    "Example: 'Ungal kodhum ₹2180/q irukku. " +
    "MSP vida adhigam, sell pannunga. " +
    "Ee week mazhai illai, spray pannunga.' " +
    "Tamil words mixed with English naturally.",

  "te-en":
    "Reply in TENGLISH — Telugu+English mix. " +
    "Example: 'Mee godhuma ₹2180/q undi. " +
    "MSP kante ekkuva, sell cheyyandi. " +
    "Ee vaaram varsham raadu, spray cheyyandi.' " +
    "Natural Telugu-English mix.",

  "kn-en":
    "Reply in KANGLISH — Kannada+English mix. " +
    "Example: 'Nimma godi ₹2180/q ide. " +
    "MSP ginta hechu, sell madi. " +
    "Ee vaara male illa, spray madi.' " +
    "Natural Kannada-English mix.",

  "ml-en":
    "Reply in MANLISH — Malayalam+English mix. " +
    "Example: 'Ningalude godhambu ₹2180/q aanu. " +
    "MSP il ekkuva, sell cheyyuka. " +
    "Ee azhcha mazha illa, spray cheyyuka.' " +
    "Natural Malayalam-English mix.",

  "or-en":
    "Reply in ODLISH — Odia+English mix. " +
    "Example: 'Aapanka gahama ₹2180/q achi. " +
    "MSP tharu besi, sell karantu. " +
    "Ei sapta barsha nahi, spray karantu.' " +
    "Natural Odia-English mix.",

  "ne-en":
    "Reply in NEPLISH — Nepali+English mix. " +
    "Example: 'Tapainko gahu ₹2180/q chha. " +
    "MSP bhandha badhi, sell garnus. " +
    "Yo hapta pani pardaina, spray garnus.' " +
    "Natural Nepali-English mix.",

  "as-en":
    "Reply in ASSLISH — Assamese+English mix. " +
    "Example: 'Aapunar ghau ₹2180/q ache. " +
    "MSP tukoi besi, sell karok. " +
    "Ei saptahat bori nai, spray karok.' " +
    "Natural Assamese-English mix.",

  "ur-en":
    "Reply in URLISH — Urdu+English mix. " +
    "Example: 'Aapka gandum ₹2180/q hai. " +
    "MSP se upar, sell karein. " +
    "Is hafte barish nahi, spray karein.' " +
    "Mix Urdu words (Roman) with English. " +
    "Roman script preferred for mix.",

  "ks-en":
    "Reply in KASHLISH — Kashmiri+English mix. " +
    "Mix Kashmiri words with English naturally. " +
    "Roman script for the mix.",

  "mni-en":
    "Reply in MEITLISH — Manipuri+English mix. " +
    "Mix Manipuri (Meitei) words with English. " +
    "Natural code-switching style."
};
